/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import http from "../httpService";
import {
    Asset,
    AssetConsumption,
    AssetsConnectorConsumptionRetrieveLastDetailData,
    AssetsConnectorsConnectionCheckDetailData,
    AssetsConnectorsConnectionCheckDetailParams,
    AssetsConsumptionsCreateData,
    AssetsConsumptionsDetailData,
    AssetsConsumptionsDetailParams,
    AssetsCreateData,
    AssetsDeleteData,
    AssetsDetailData,
    AssetsDetailParams,
    AssetsListData,
    AssetsListParams,
    AssetsStatusInErrorListData,
    AssetsStatusInErrorListParams,
    AssetsUpdateData,
    BillingAccountsCreateData,
    BillingAccountsCreatePayload,
    BillingAccountsDetailData,
    BillingAccountsListData,
    BillingAccountsListParams,
    BillingAccountsOnboardPartialUpdateData,
    BillingCheckCreateData,
    BillingSettingListData,
    BillingSettingUpdateData,
    BillingSettingUpdatePayload,
    BillingTaxesListData,
    BillingTransfersFinalizePartialUpdateData,
    BillingTransfersListData,
    BillingTransfersListParams,
    BillingTransfersSendPartialUpdateData,
    Car,
    CarCatalogsActionSynchronizeCreateData,
    CarCatalogsDetailData,
    CarCatalogsDetailParams,
    CarCatalogsImagesDetailData,
    CarCatalogsImagesDetailParams,
    CarCatalogsListData,
    CarCatalogsListParams,
    CarMakersListData,
    CarMakersListParams,
    CarsCreate2Data,
    CarsCreateData,
    CarsDeleteData,
    CarsDeleteParams,
    CarsDetailData,
    CarsDetailParams,
    CarsListData,
    CarsListParams,
    CarsUpdateData,
    CarsUpdateParams,
    ChargingProfile,
    ChargingProfilesCreateData,
    ChargingProfilesDeleteData,
    ChargingProfilesListData,
    ChargingProfilesListParams,
    ChargingProfilesUpdateData,
    ChargingStationsActionExportListData,
    ChargingStationsActionExportListParams,
    ChargingStationsAvailabilityChangeUpdateData,
    ChargingStationsAvailabilityChangeUpdatePayload,
    ChargingStationsCacheClearUpdateData,
    ChargingStationsCompositeScheduleGetUpdateData,
    ChargingStationsCompositeScheduleGetUpdatePayload,
    ChargingStationsConfigurationRetrieveUpdateData,
    ChargingStationsConfigurationRetrieveUpdatePayload,
    ChargingStationsConfigurationUpdateData,
    ChargingStationsConfigurationUpdatePayload,
    ChargingStationsConnectorsQrcodeGenerateDetailData,
    ChargingStationsConnectorsUnlockUpdateData,
    ChargingStationsDataTransferUpdateData,
    ChargingStationsDataTransferUpdatePayload,
    ChargingStationsDeleteData,
    ChargingStationsDetailData,
    ChargingStationsDetailParams,
    ChargingStationsDiagnosticsGetUpdateData,
    ChargingStationsDiagnosticsGetUpdatePayload,
    ChargingStationsFirmwareUpdateUpdateData,
    ChargingStationsFirmwareUpdateUpdatePayload,
    ChargingStationsListData,
    ChargingStationsListParams,
    ChargingStationsNotificationsBootListData,
    ChargingStationsNotificationsBootListParams,
    ChargingStationsNotificationsStatusListData,
    ChargingStationsNotificationsStatusListParams,
    ChargingStationsOcppParametersCreateData,
    ChargingStationsOcppParametersCreatePayload,
    ChargingStationsOcppParametersDetailData,
    ChargingStationsOcppParametersExportListData,
    ChargingStationsOcppParametersExportListParams,
    ChargingStationsParametersUpdateData,
    ChargingStationsParametersUpdatePayload,
    ChargingStationsPowerLimitUpdateData,
    ChargingStationsPowerLimitUpdatePayload,
    ChargingStationsQrcodeDownloadListData,
    ChargingStationsQrcodeDownloadListParams,
    ChargingStationsRemoteStartUpdateData,
    ChargingStationsRemoteStartUpdatePayload,
    ChargingStationsRemoteStopUpdateData,
    ChargingStationsRemoteStopUpdatePayload,
    ChargingStationsReservationCancelUpdateData,
    ChargingStationsReservationCancelUpdatePayload,
    ChargingStationsReserveNowUpdateData,
    ChargingStationsReserveNowUpdatePayload,
    ChargingStationsResetUpdateData,
    ChargingStationsResetUpdatePayload,
    ChargingStationsSmartchargingConnectionCheckListData,
    ChargingStationsSmartchargingTriggerListData,
    ChargingStationsSmartchargingTriggerListParams,
    ChargingStationsStatusInErrorListData,
    ChargingStationsStatusInErrorListParams,
    ChargingStationsTransactionsDetailData,
    ChargingStationsTransactionsDetailParams,
    CompaniesCreateData,
    CompaniesDeleteData,
    CompaniesDetailData,
    CompaniesListData,
    CompaniesListParams,
    CompaniesUpdateData,
    Company,
    ConnectionsCreateData,
    ConnectionsCreatePayload,
    ConnectionsDeleteData,
    ConnectionsDetailData,
    ConnectionsListData,
    ConnectionsListParams,
    InvoicesDetailData,
    InvoicesDownloadDetailData,
    InvoicesListData,
    InvoicesListParams,
    LogsActionExportListData,
    LogsActionExportListParams,
    LogsDetailData,
    LogsListData,
    LogsListParams,
    NotificationsActionEndUserReportErrorCreateData,
    NotificationsActionEndUserReportErrorCreatePayload,
    NotificationsListData,
    NotificationsListParams,
    OCPIEndpoint,
    OcpiEndpointsCdrsCheckUpdateData,
    OcpiEndpointsCdrsPullUpdateData,
    OcpiEndpointsCreateData,
    OcpiEndpointsCredentialsUpdateData,
    OcpiEndpointsDeleteData,
    OcpiEndpointsDetailData,
    OcpiEndpointsEvsesStatusesSendUpdateData,
    OcpiEndpointsListData,
    OcpiEndpointsListParams,
    OcpiEndpointsLocationsCheckUpdateData,
    OcpiEndpointsLocationsPullUpdateData,
    OcpiEndpointsPingUpdateData,
    OcpiEndpointsRegisterUpdateData,
    OcpiEndpointsSessionsCheckUpdateData,
    OcpiEndpointsSessionsPullUpdateData,
    OcpiEndpointsTokensGenerateUpdateData,
    OcpiEndpointsTokensGenerateUpdatePayload,
    OcpiEndpointsTokensPullUpdateData,
    OcpiEndpointsTokensSendUpdateData,
    OcpiEndpointsUnregisterUpdateData,
    OcpiEndpointsUpdateData,
    OICPEndpoint,
    OicpEndpointsCreateData,
    OicpEndpointsDeleteData,
    OicpEndpointsDetailData,
    OicpEndpointsEvsesSendUpdateData,
    OicpEndpointsEvsesStatusesSendUpdateData,
    OicpEndpointsPingUpdateData,
    OicpEndpointsRegisterUpdateData,
    OicpEndpointsUnregisterUpdateData,
    OicpEndpointsUpdateData,
    PricingDefinitionsDetailData,
    PricingDefinitionsListData,
    PricingDefinitionsListParams,
    PricingModelResolveListData,
    PricingModelResolveListParams,
    RegistrationToken,
    RegistrationTokensCreateData,
    RegistrationTokensDeleteData,
    RegistrationTokensDetailData,
    RegistrationTokensListData,
    RegistrationTokensListParams,
    RegistrationTokensRevokeUpdateData,
    RegistrationTokensUpdateData,
    Setting,
    SettingsCreateData,
    SettingsDeleteData,
    SettingsDetailData,
    SettingsListData,
    SettingsListParams,
    SettingsUpdateData,
    Site,
    SiteArea,
    SiteAreasAssetsAssignUpdateData,
    SiteAreasAssetsAssignUpdatePayload,
    SiteAreasAssetsUnassignUpdateData,
    SiteAreasAssetsUnassignUpdatePayload,
    SiteAreasChargingStationsAssignUpdateData,
    SiteAreasChargingStationsAssignUpdatePayload,
    SiteAreasChargingStationsUnassignUpdateData,
    SiteAreasChargingStationsUnassignUpdatePayload,
    SiteAreasConsumptionsDetailData,
    SiteAreasConsumptionsDetailParams,
    SiteAreasCreateData,
    SiteAreasDeleteData,
    SiteAreasDetailData,
    SiteAreasDetailParams,
    SiteAreasListData,
    SiteAreasListParams,
    SiteAreasUpdateData,
    SitesAssignUpdateData,
    SitesAssignUpdatePayload,
    SitesCreateData,
    SitesDeleteData,
    SitesDetailData,
    SitesListData,
    SitesListParams,
    SitesUnassignUpdateData,
    SitesUnassignUpdatePayload,
    SitesUpdateData,
    SitesUsersAdminUpdateData,
    SitesUsersAdminUpdatePayload,
    SitesUsersDetailData,
    SitesUsersOwnerUpdateData,
    SitesUsersOwnerUpdatePayload,
    StatisticsActionExportListData,
    StatisticsActionExportListParams,
    StatisticsChargingStationsConsumptionListData,
    StatisticsChargingStationsConsumptionListParams,
    StatisticsChargingStationsInactivityListData,
    StatisticsChargingStationsInactivityListParams,
    StatisticsChargingStationsPricingListData,
    StatisticsChargingStationsPricingListParams,
    StatisticsChargingStationsTransactionsListData,
    StatisticsChargingStationsTransactionsListParams,
    StatisticsChargingStationsUsageListData,
    StatisticsChargingStationsUsageListParams,
    StatisticsUsersConsumptionListData,
    StatisticsUsersConsumptionListParams,
    StatisticsUsersInactivityListData,
    StatisticsUsersInactivityListParams,
    StatisticsUsersPricingListData,
    StatisticsUsersPricingListParams,
    StatisticsUsersTransactionsListData,
    StatisticsUsersTransactionsListParams,
    StatisticsUsersUsageListData,
    StatisticsUsersUsageListParams,
    Tag,
    TagsActionExportListData,
    TagsActionExportListParams,
    TagsActionImportCreateData,
    TagsActionImportCreatePayload,
    TagsAssignUpdateData,
    TagsAssignUpdatePayload,
    TagsCreateData,
    TagsDelete2Data,
    TagsDeleteData,
    TagsDeletePayload,
    TagsDetailData,
    TagsDetailParams,
    TagsListData,
    TagsListParams,
    TagsUnassignUpdate2Data,
    TagsUnassignUpdate2Payload,
    TagsUnassignUpdateData,
    TagsUpdateData,
    TagsUpdatePayload,
    Tenant,
    TenantsCreateData,
    TenantsDeleteData,
    TenantsDetailData,
    TenantsDetailParams,
    TenantsListData,
    TenantsListParams,
    TenantsUpdateData,
    TransactionsActionExportListData,
    TransactionsActionExportListParams,
    TransactionsActionRefundCreateData,
    TransactionsActionRefundCreatePayload,
    TransactionsConsumptionsDetailData,
    TransactionsConsumptionsDetailParams,
    TransactionsDelete2Data,
    TransactionsDeleteData,
    TransactionsDeletePayload,
    TransactionsDetailData,
    TransactionsDetailParams,
    TransactionsListData,
    TransactionsListParams,
    TransactionsOcpiCdrCreateData,
    TransactionsOcpiCdrExportDetailData,
    TransactionsSoftStopUpdateData,
    TransactionsStartUpdateData,
    TransactionsStartUpdatePayload,
    TransactionsStatusActiveListData,
    TransactionsStatusActiveListParams,
    TransactionsStatusCompletedListData,
    TransactionsStatusCompletedListParams,
    TransactionsStatusInErrorListData,
    TransactionsStatusInErrorListParams,
    TransactionsStatusRefundExportListData,
    TransactionsStatusRefundExportListParams,
    TransactionsStatusRefundListData,
    TransactionsStatusRefundListParams,
    TransactionsStatusRefundReportsListData,
    TransactionsStatusRefundReportsListParams,
    TransactionsStatusRefundSynchronizeCreateData,
    TransactionsStopUpdateData,
    User,
    UsersActionExportListData,
    UsersActionExportListParams,
    UsersActionImportCreateData,
    UsersActionImportCreatePayload,
    UsersCreateData,
    UsersDefaultCarTagDetailData,
    UsersDeleteData,
    UsersDetailData,
    UsersDetailParams,
    UsersImageDetailData,
    UsersListData,
    UsersListParams,
    UsersMobileDataUpdateData,
    UsersMobileDataUpdatePayload,
    UsersPaymentMethodsDeleteData,
    UsersPaymentMethodsDetailData,
    UsersPaymentMethodsDetailParams,
    UsersPaymentMethodsSetupCreateData,
    UsersPaymentMethodsSetupCreatePayload,
    UsersSessionContextDetailData,
    UsersSessionContextDetailParams,
    UsersSitesCreateData,
    UsersSitesCreatePayload,
    UsersSitesDetailData,
    UsersSitesUpdateData,
    UsersSitesUpdatePayload,
    UsersStatusInErrorListData,
    UsersStatusInErrorListParams,
    UsersUpdateData,
    UsersUpdatePayload,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

class Api<SecurityDataType = unknown> {
    http: HttpClient<SecurityDataType>;

    constructor(http: HttpClient<SecurityDataType>) {
        this.http = http;
    }

    /**
     * @description Retrieve a list of Tenants
     *
     * @tags Tenant
     * @name TenantsList
     * @request GET:/api/tenants
     * @secure
     * @response `200` `TenantsListData` Return the tenant list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    tenantsList = (query: TenantsListParams, params: RequestParams = {}) =>
        this.http.request<TenantsListData, any>({
            path: `/api/tenants`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Create a Tenant
     *
     * @tags Tenant
     * @name TenantsCreate
     * @request POST:/api/tenants
     * @response `200` `TenantsCreateData` Tenant is created with success
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    tenantsCreate = (data: Tenant, params: RequestParams = {}) =>
        this.http.request<TenantsCreateData, any>({
            path: `/api/tenants`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Retrieve a Tenant
     *
     * @tags Tenant
     * @name TenantsDetail
     * @request GET:/api/tenants/{id}
     * @secure
     * @response `200` `TenantsDetailData` Return the found Tenant
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    tenantsDetail = ({ id, ...query }: TenantsDetailParams, params: RequestParams = {}) =>
        this.http.request<TenantsDetailData, any>({
            path: `/api/tenants/${id}`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Delete a Tenant
     *
     * @tags Tenant
     * @name TenantsDelete
     * @request DELETE:/api/tenants/{id}
     * @secure
     * @response `200` `TenantsDeleteData` Tenant has been successfully deleted
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    tenantsDelete = (id: string, params: RequestParams = {}) =>
        this.http.request<TenantsDeleteData, any>({
            path: `/api/tenants/${id}`,
            method: "DELETE",
            secure: true,
            ...params,
        });
    /**
     * @description Update a Tenant
     *
     * @tags Tenant
     * @name TenantsUpdate
     * @request PUT:/api/tenants/{id}
     * @secure
     * @response `200` `TenantsUpdateData` Tenant has been successfully updated
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    tenantsUpdate = (id: string, data: Tenant, params: RequestParams = {}) =>
        this.http.request<TenantsUpdateData, any>({
            path: `/api/tenants/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Retrieve a list of Site Areas
     *
     * @tags Site Area
     * @name SiteAreasList
     * @request GET:/api/site-areas
     * @secure
     * @response `200` `SiteAreasListData` Return the site area list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    siteAreasList = (query: SiteAreasListParams, params: RequestParams = {}) =>
        this.http.request<SiteAreasListData, any>({
            path: `/api/site-areas`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Create a SiteArea
     *
     * @tags Site Area
     * @name SiteAreasCreate
     * @request POST:/api/site-areas
     * @secure
     * @response `200` `SiteAreasCreateData` Site Area is created with success
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     * @response `540` `any`
     * @response `541` `any`
     * @response `542` `any`
     * @response `543` `any`
     * @response `544` `any`
     * @response `545` `any`
     * @response `546` `any`
     * @response `547` `any`
     */
    siteAreasCreate = (data: SiteArea, params: RequestParams = {}) =>
        this.http.request<SiteAreasCreateData, any>({
            path: `/api/site-areas`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Retrieve a Site Area
     *
     * @tags Site Area
     * @name SiteAreasDetail
     * @request GET:/api/site-areas/{id}
     * @secure
     * @response `200` `SiteAreasDetailData` Return the site area
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    siteAreasDetail = ({ id, ...query }: SiteAreasDetailParams, params: RequestParams = {}) =>
        this.http.request<SiteAreasDetailData, any>({
            path: `/api/site-areas/${id}`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Update a SiteArea
     *
     * @tags Site Area
     * @name SiteAreasUpdate
     * @request PUT:/api/site-areas/{id}
     * @secure
     * @response `200` `SiteAreasUpdateData` Site Area is updated with success
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     * @response `537` `void` Error occurred while clearing Charging Profiles for Site Area
     * @response `539` `void` One of the charging stations is not single phased
     * @response `540` `any`
     * @response `541` `any`
     * @response `542` `any`
     * @response `543` `any`
     * @response `544` `any`
     * @response `545` `any`
     * @response `546` `any`
     * @response `547` `any`
     */
    siteAreasUpdate = (id: string, data: SiteArea, params: RequestParams = {}) =>
        this.http.request<SiteAreasUpdateData, void>({
            path: `/api/site-areas/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Delete a SiteArea
     *
     * @tags Site Area
     * @name SiteAreasDelete
     * @request DELETE:/api/site-areas/{id}
     * @secure
     * @response `200` `SiteAreasDeleteData` Site Area is deleted with success
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     * @response `543` `any`
     */
    siteAreasDelete = (id: string, params: RequestParams = {}) =>
        this.http.request<SiteAreasDeleteData, any>({
            path: `/api/site-areas/${id}`,
            method: "DELETE",
            secure: true,
            ...params,
        });
    /**
     * @description Retrieve Site Area consumptions
     *
     * @tags Site Area
     * @name SiteAreasConsumptionsDetail
     * @request GET:/api/site-areas/{id}/consumptions
     * @secure
     * @response `200` `SiteAreasConsumptionsDetailData` Return the site area's consumption
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    siteAreasConsumptionsDetail = ({ id, ...query }: SiteAreasConsumptionsDetailParams, params: RequestParams = {}) =>
        this.http.request<SiteAreasConsumptionsDetailData, any>({
            path: `/api/site-areas/${id}/consumptions`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Assign charging stations to a Site Area
     *
     * @tags Site Area
     * @name SiteAreasChargingStationsAssignUpdate
     * @request PUT:/api/site-areas/{id}/charging-stations/assign
     * @secure
     * @response `200` `SiteAreasChargingStationsAssignUpdateData` Charging stations assigned successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    siteAreasChargingStationsAssignUpdate = (
        id: string,
        data: SiteAreasChargingStationsAssignUpdatePayload,
        params: RequestParams = {}
    ) =>
        this.http.request<SiteAreasChargingStationsAssignUpdateData, any>({
            path: `/api/site-areas/${id}/charging-stations/assign`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Unassign charging stations from a Site Area
     *
     * @tags Site Area
     * @name SiteAreasChargingStationsUnassignUpdate
     * @request PUT:/api/site-areas/{id}/charging-stations/unassign
     * @secure
     * @response `200` `SiteAreasChargingStationsUnassignUpdateData` Charging stations unassigned successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    siteAreasChargingStationsUnassignUpdate = (
        id: string,
        data: SiteAreasChargingStationsUnassignUpdatePayload,
        params: RequestParams = {}
    ) =>
        this.http.request<SiteAreasChargingStationsUnassignUpdateData, any>({
            path: `/api/site-areas/${id}/charging-stations/unassign`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Assign assets to a Site Area
     *
     * @tags Site Area
     * @name SiteAreasAssetsAssignUpdate
     * @request PUT:/api/site-areas/{id}/assets/assign
     * @secure
     * @response `200` `SiteAreasAssetsAssignUpdateData` Assets assigned successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    siteAreasAssetsAssignUpdate = (id: string, data: SiteAreasAssetsAssignUpdatePayload, params: RequestParams = {}) =>
        this.http.request<SiteAreasAssetsAssignUpdateData, any>({
            path: `/api/site-areas/${id}/assets/assign`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Unassign assets from a Site Area
     *
     * @tags Site Area
     * @name SiteAreasAssetsUnassignUpdate
     * @request PUT:/api/site-areas/{id}/assets/unassign
     * @secure
     * @response `200` `SiteAreasAssetsUnassignUpdateData` Charging stations unassigned successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    siteAreasAssetsUnassignUpdate = (
        id: string,
        data: SiteAreasAssetsUnassignUpdatePayload,
        params: RequestParams = {}
    ) =>
        this.http.request<SiteAreasAssetsUnassignUpdateData, any>({
            path: `/api/site-areas/${id}/assets/unassign`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Retrieve a list of Transactions
     *
     * @tags Transactions
     * @name TransactionsList
     * @request GET:/api/transactions
     * @secure
     * @response `200` `TransactionsListData` Return Transaction's list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    transactionsList = (query: TransactionsListParams, params: RequestParams = {}) =>
        this.http.request<TransactionsListData, any>({
            path: `/api/transactions`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Delete several Transactions
     *
     * @tags Transactions
     * @name TransactionsDelete
     * @request DELETE:/api/transactions
     * @secure
     * @response `200` `TransactionsDeleteData` Transaction deletion result
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    transactionsDelete = (data: TransactionsDeletePayload, params: RequestParams = {}) =>
        this.http.request<TransactionsDeleteData, any>({
            path: `/api/transactions`,
            method: "DELETE",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Retrieve a list of completed Transactions
     *
     * @tags Transactions
     * @name TransactionsStatusCompletedList
     * @request GET:/api/transactions/status/completed
     * @secure
     * @response `200` `TransactionsStatusCompletedListData` Return completed Transaction's list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    transactionsStatusCompletedList = (query: TransactionsStatusCompletedListParams, params: RequestParams = {}) =>
        this.http.request<TransactionsStatusCompletedListData, any>({
            path: `/api/transactions/status/completed`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Retrieve a list of active Transactions
     *
     * @tags Transactions
     * @name TransactionsStatusActiveList
     * @request GET:/api/transactions/status/active
     * @secure
     * @response `200` `TransactionsStatusActiveListData` Return active Transaction's list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    transactionsStatusActiveList = (query: TransactionsStatusActiveListParams, params: RequestParams = {}) =>
        this.http.request<TransactionsStatusActiveListData, any>({
            path: `/api/transactions/status/active`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Retrieve a list of Transactions to refund and refunded
     *
     * @tags Transactions
     * @name TransactionsStatusRefundList
     * @request GET:/api/transactions/status/refund
     * @secure
     * @response `200` `TransactionsStatusRefundListData` Return Transactions to refund and refunded list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    transactionsStatusRefundList = (query: TransactionsStatusRefundListParams, params: RequestParams = {}) =>
        this.http.request<TransactionsStatusRefundListData, any>({
            path: `/api/transactions/status/refund`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Retrieve a list of Transactions in error
     *
     * @tags Transactions
     * @name TransactionsStatusInErrorList
     * @request GET:/api/transactions/status/in-error
     * @secure
     * @response `200` `TransactionsStatusInErrorListData` Return Transactions in error list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    transactionsStatusInErrorList = (query: TransactionsStatusInErrorListParams, params: RequestParams = {}) =>
        this.http.request<TransactionsStatusInErrorListData, any>({
            path: `/api/transactions/status/in-error`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Retrieve a Transaction
     *
     * @tags Transactions
     * @name TransactionsDetail
     * @request GET:/api/transactions/{id}
     * @secure
     * @response `200` `TransactionsDetailData` Returned Transaction
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    transactionsDetail = ({ id, ...query }: TransactionsDetailParams, params: RequestParams = {}) =>
        this.http.request<TransactionsDetailData, any>({
            path: `/api/transactions/${id}`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Delete a Transaction
     *
     * @tags Transactions
     * @name TransactionsDelete2
     * @request DELETE:/api/transactions/{id}
     * @originalName transactionsDelete
     * @duplicate
     * @secure
     * @response `200` `TransactionsDelete2Data` Transaction deletion result
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    transactionsDelete2 = (id: string, params: RequestParams = {}) =>
        this.http.request<TransactionsDelete2Data, any>({
            path: `/api/transactions/${id}`,
            method: "DELETE",
            secure: true,
            ...params,
        });
    /**
     * @description Push Transaction CDR
     *
     * @tags Transactions
     * @name TransactionsOcpiCdrCreate
     * @request POST:/api/transactions/{id}/ocpi/cdr
     * @secure
     * @response `200` `TransactionsOcpiCdrCreateData` Transaction CDR pushed successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     * @response `580` `void` The transaction belongs to an external organization
     * @response `581` `void` The transaction has no OCPI or OICP session data
     * @response `582` `void` The CDR of the transaction has already been pushed
     */
    transactionsOcpiCdrCreate = (id: string, params: RequestParams = {}) =>
        this.http.request<TransactionsOcpiCdrCreateData, void>({
            path: `/api/transactions/${id}/ocpi/cdr`,
            method: "POST",
            secure: true,
            ...params,
        });
    /**
     * @description Export Transaction CDR
     *
     * @tags Transactions
     * @name TransactionsOcpiCdrExportDetail
     * @request GET:/api/transactions/{id}/ocpi/cdr/export
     * @secure
     * @response `200` `TransactionsOcpiCdrExportDetailData` Exported Transaction CDR
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     * @response `580` `void` The transaction belongs to an external organization
     * @response `581` `void` The transaction has no OCPI or OICP session data
     * @response `582` `void` The CDR of the transaction has already been pushed
     */
    transactionsOcpiCdrExportDetail = (id: string, params: RequestParams = {}) =>
        this.http.request<TransactionsOcpiCdrExportDetailData, void>({
            path: `/api/transactions/${id}/ocpi/cdr/export`,
            method: "GET",
            secure: true,
            ...params,
        });
    /**
     * @description Retrieve a Transaction consumption
     *
     * @tags Transactions
     * @name TransactionsConsumptionsDetail
     * @request GET:/api/transactions/{id}/consumptions
     * @secure
     * @response `200` `TransactionsConsumptionsDetailData` Return a Transaction consumption
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    transactionsConsumptionsDetail = (
        { id, ...query }: TransactionsConsumptionsDetailParams,
        params: RequestParams = {}
    ) =>
        this.http.request<TransactionsConsumptionsDetailData, any>({
            path: `/api/transactions/${id}/consumptions`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Start a Transaction by using the right method (OCPP, OCPI...)
     *
     * @tags Transactions
     * @name TransactionsStartUpdate
     * @request PUT:/api/transactions/start
     * @secure
     * @response `200` `TransactionsStartUpdateData` Transaction started successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    transactionsStartUpdate = (data: TransactionsStartUpdatePayload, params: RequestParams = {}) =>
        this.http.request<TransactionsStartUpdateData, any>({
            path: `/api/transactions/start`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Stop a Transaction by using the right method (OCPP, OCPI, Soft...)
     *
     * @tags Transactions
     * @name TransactionsStopUpdate
     * @request PUT:/api/transactions/{id}/stop
     * @secure
     * @response `200` `TransactionsStopUpdateData` Transaction stopped successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    transactionsStopUpdate = (id: string, params: RequestParams = {}) =>
        this.http.request<TransactionsStopUpdateData, any>({
            path: `/api/transactions/${id}/stop`,
            method: "PUT",
            secure: true,
            ...params,
        });
    /**
     * @description Stop a Transaction without calling the Charging Station
     *
     * @tags Transactions
     * @name TransactionsSoftStopUpdate
     * @request PUT:/api/transactions/{id}/soft-stop
     * @secure
     * @response `200` `TransactionsSoftStopUpdateData` Transaction stopped successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    transactionsSoftStopUpdate = (id: string, params: RequestParams = {}) =>
        this.http.request<TransactionsSoftStopUpdateData, any>({
            path: `/api/transactions/${id}/soft-stop`,
            method: "PUT",
            secure: true,
            ...params,
        });
    /**
     * @description Refund Transactions
     *
     * @tags Transactions
     * @name TransactionsActionRefundCreate
     * @request POST:/api/transactions/action/refund
     * @secure
     * @response `200` `TransactionsActionRefundCreateData` Transactions refund result
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     * @response `552` `void` No Refund valid connection found
     */
    transactionsActionRefundCreate = (data: TransactionsActionRefundCreatePayload, params: RequestParams = {}) =>
        this.http.request<TransactionsActionRefundCreateData, void>({
            path: `/api/transactions/action/refund`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Export Transactions to refund
     *
     * @tags Transactions
     * @name TransactionsStatusRefundExportList
     * @request GET:/api/transactions/status/refund/export
     * @secure
     * @response `200` `TransactionsStatusRefundExportListData` Exported Transactions to refund
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    transactionsStatusRefundExportList = (
        query: TransactionsStatusRefundExportListParams,
        params: RequestParams = {}
    ) =>
        this.http.request<TransactionsStatusRefundExportListData, any>({
            path: `/api/transactions/status/refund/export`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Synchronize refunded Transactions
     *
     * @tags Transactions
     * @name TransactionsStatusRefundSynchronizeCreate
     * @request POST:/api/transactions/status/refund/synchronize
     * @secure
     * @response `200` `TransactionsStatusRefundSynchronizeCreateData` Synchronized refunded transactions successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    transactionsStatusRefundSynchronizeCreate = (params: RequestParams = {}) =>
        this.http.request<TransactionsStatusRefundSynchronizeCreateData, any>({
            path: `/api/transactions/status/refund/synchronize`,
            method: "POST",
            secure: true,
            ...params,
        });
    /**
     * @description Retrieve Transactions refund reports
     *
     * @tags Transactions
     * @name TransactionsStatusRefundReportsList
     * @request GET:/api/transactions/status/refund/reports
     * @secure
     * @response `200` `TransactionsStatusRefundReportsListData` Retrieved Transactions refund reports
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    transactionsStatusRefundReportsList = (
        query: TransactionsStatusRefundReportsListParams,
        params: RequestParams = {}
    ) =>
        this.http.request<TransactionsStatusRefundReportsListData, any>({
            path: `/api/transactions/status/refund/reports`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Export Transactions
     *
     * @tags Transactions
     * @name TransactionsActionExportList
     * @request GET:/api/transactions/action/export
     * @secure
     * @response `200` `TransactionsActionExportListData` Transactions successfully exported
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    transactionsActionExportList = (query: TransactionsActionExportListParams, params: RequestParams = {}) =>
        this.http.request<TransactionsActionExportListData, any>({
            path: `/api/transactions/action/export`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Retrieve a list of Charging Stations
     *
     * @tags Charging Stations
     * @name ChargingStationsList
     * @request GET:/api/charging-stations
     * @secure
     * @response `200` `ChargingStationsListData` Return Charging Stations list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    chargingStationsList = (query: ChargingStationsListParams, params: RequestParams = {}) =>
        this.http.request<ChargingStationsListData, any>({
            path: `/api/charging-stations`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Retrieve a Charging Station
     *
     * @tags Charging Stations
     * @name ChargingStationsDetail
     * @request GET:/api/charging-stations/{id}
     * @secure
     * @response `200` `ChargingStationsDetailData` Charging Station
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    chargingStationsDetail = ({ id, ...query }: ChargingStationsDetailParams, params: RequestParams = {}) =>
        this.http.request<ChargingStationsDetailData, any>({
            path: `/api/charging-stations/${id}`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Delete a Charging Station
     *
     * @tags Charging Stations
     * @name ChargingStationsDelete
     * @request DELETE:/api/charging-stations/{id}
     * @secure
     * @response `200` `ChargingStationsDeleteData` Charging Station has been successfully deleted
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `void` Charging Station does not exist
     * @response `500` `any`
     * @response `570` `void` Charging Station can't be deleted due to existing active transactions
     */
    chargingStationsDelete = (id: string, params: RequestParams = {}) =>
        this.http.request<ChargingStationsDeleteData, void>({
            path: `/api/charging-stations/${id}`,
            method: "DELETE",
            secure: true,
            ...params,
        });
    /**
     * @description Reserve a Charging Station
     *
     * @tags Charging Stations
     * @name ChargingStationsReserveNowUpdate
     * @request PUT:/api/charging-stations/{id}/reserve/now
     * @secure
     * @response `200` `ChargingStationsReserveNowUpdateData` Charging Station has been successfully reserved
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    chargingStationsReserveNowUpdate = (
        id: string,
        data: ChargingStationsReserveNowUpdatePayload,
        params: RequestParams = {}
    ) =>
        this.http.request<ChargingStationsReserveNowUpdateData, any>({
            path: `/api/charging-stations/${id}/reserve/now`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Reset a Charging Station
     *
     * @tags Charging Stations
     * @name ChargingStationsResetUpdate
     * @request PUT:/api/charging-stations/{id}/reset
     * @secure
     * @response `200` `ChargingStationsResetUpdateData` Charging Station has been successfully reset
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    chargingStationsResetUpdate = (id: string, data: ChargingStationsResetUpdatePayload, params: RequestParams = {}) =>
        this.http.request<ChargingStationsResetUpdateData, any>({
            path: `/api/charging-stations/${id}/reset`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Clear a Charging Station cache
     *
     * @tags Charging Stations
     * @name ChargingStationsCacheClearUpdate
     * @request PUT:/api/charging-stations/{id}/cache/clear
     * @secure
     * @response `200` `ChargingStationsCacheClearUpdateData` Charging Station cache has been successfully cleared
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    chargingStationsCacheClearUpdate = (id: string, params: RequestParams = {}) =>
        this.http.request<ChargingStationsCacheClearUpdateData, any>({
            path: `/api/charging-stations/${id}/cache/clear`,
            method: "PUT",
            secure: true,
            ...params,
        });
    /**
     * @description Cancel Reservation
     *
     * @tags Charging Stations
     * @name ChargingStationsReservationCancelUpdate
     * @request PUT:/api/charging-stations/{id}/reservation/cancel
     * @secure
     * @response `200` `ChargingStationsReservationCancelUpdateData` Reservation has been successfully cancelled
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    chargingStationsReservationCancelUpdate = (
        id: string,
        data: ChargingStationsReservationCancelUpdatePayload,
        params: RequestParams = {}
    ) =>
        this.http.request<ChargingStationsReservationCancelUpdateData, any>({
            path: `/api/charging-stations/${id}/reservation/cancel`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Trigger Data Transfer
     *
     * @tags Charging Stations
     * @name ChargingStationsDataTransferUpdate
     * @request PUT:/api/charging-stations/{id}/data/transfer
     * @secure
     * @response `200` `ChargingStationsDataTransferUpdateData` Data Transfer has been successfully executed
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    chargingStationsDataTransferUpdate = (
        id: string,
        data: ChargingStationsDataTransferUpdatePayload,
        params: RequestParams = {}
    ) =>
        this.http.request<ChargingStationsDataTransferUpdateData, any>({
            path: `/api/charging-stations/${id}/data/transfer`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Get the Charging Station's configuration
     *
     * @tags Charging Stations
     * @name ChargingStationsConfigurationRetrieveUpdate
     * @request PUT:/api/charging-stations/{id}/configuration/retrieve
     * @secure
     * @response `200` `ChargingStationsConfigurationRetrieveUpdateData` Return the configuration
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    chargingStationsConfigurationRetrieveUpdate = (
        id: string,
        data: ChargingStationsConfigurationRetrieveUpdatePayload,
        params: RequestParams = {}
    ) =>
        this.http.request<ChargingStationsConfigurationRetrieveUpdateData, any>({
            path: `/api/charging-stations/${id}/configuration/retrieve`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Update the Charging Station's configuration
     *
     * @tags Charging Stations
     * @name ChargingStationsConfigurationUpdate
     * @request PUT:/api/charging-stations/{id}/configuration
     * @secure
     * @response `200` `ChargingStationsConfigurationUpdateData` Return command success status
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    chargingStationsConfigurationUpdate = (
        id: string,
        data: ChargingStationsConfigurationUpdatePayload,
        params: RequestParams = {}
    ) =>
        this.http.request<ChargingStationsConfigurationUpdateData, any>({
            path: `/api/charging-stations/${id}/configuration`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Start a remote transaction
     *
     * @tags Charging Stations
     * @name ChargingStationsRemoteStartUpdate
     * @request PUT:/api/charging-stations/{id}/remote/start
     * @secure
     * @response `200` `ChargingStationsRemoteStartUpdateData` Remote transaction started
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     * @response `570` `any`
     */
    chargingStationsRemoteStartUpdate = (
        id: string,
        data: ChargingStationsRemoteStartUpdatePayload,
        params: RequestParams = {}
    ) =>
        this.http.request<ChargingStationsRemoteStartUpdateData, any>({
            path: `/api/charging-stations/${id}/remote/start`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Stop a remote transaction
     *
     * @tags Charging Stations
     * @name ChargingStationsRemoteStopUpdate
     * @request PUT:/api/charging-stations/{id}/remote/stop
     * @secure
     * @response `200` `ChargingStationsRemoteStopUpdateData` Remote transaction stopped
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     * @response `570` `any`
     */
    chargingStationsRemoteStopUpdate = (
        id: string,
        data: ChargingStationsRemoteStopUpdatePayload,
        params: RequestParams = {}
    ) =>
        this.http.request<ChargingStationsRemoteStopUpdateData, any>({
            path: `/api/charging-stations/${id}/remote/stop`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Unlock a connector
     *
     * @tags Charging Stations
     * @name ChargingStationsConnectorsUnlockUpdate
     * @request PUT:/api/charging-stations/{id}/connectors/{connectorId}/unlock
     * @secure
     * @response `200` `ChargingStationsConnectorsUnlockUpdateData` Connector unlocked
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    chargingStationsConnectorsUnlockUpdate = (id: string, connectorId: number, params: RequestParams = {}) =>
        this.http.request<ChargingStationsConnectorsUnlockUpdateData, any>({
            path: `/api/charging-stations/${id}/connectors/${connectorId}/unlock`,
            method: "PUT",
            secure: true,
            ...params,
        });
    /**
     * @description Get Charging Station composite schedule
     *
     * @tags Charging Stations
     * @name ChargingStationsCompositeScheduleGetUpdate
     * @request PUT:/api/charging-stations/{id}/composite-schedule/get
     * @secure
     * @response `200` `ChargingStationsCompositeScheduleGetUpdateData` Return composite schedule
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     * @response `585` `any`
     */
    chargingStationsCompositeScheduleGetUpdate = (
        id: string,
        data: ChargingStationsCompositeScheduleGetUpdatePayload,
        params: RequestParams = {}
    ) =>
        this.http.request<ChargingStationsCompositeScheduleGetUpdateData, any>({
            path: `/api/charging-stations/${id}/composite-schedule/get`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Get Charging Station diagnostics
     *
     * @tags Charging Stations
     * @name ChargingStationsDiagnosticsGetUpdate
     * @request PUT:/api/charging-stations/{id}/diagnostics/get
     * @secure
     * @response `200` `ChargingStationsDiagnosticsGetUpdateData` Return charging station diagnostic filename
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    chargingStationsDiagnosticsGetUpdate = (
        id: string,
        data: ChargingStationsDiagnosticsGetUpdatePayload,
        params: RequestParams = {}
    ) =>
        this.http.request<ChargingStationsDiagnosticsGetUpdateData, any>({
            path: `/api/charging-stations/${id}/diagnostics/get`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Update Charging Station firmware
     *
     * @tags Charging Stations
     * @name ChargingStationsFirmwareUpdateUpdate
     * @request PUT:/api/charging-stations/{id}/firmware/update
     * @secure
     * @response `200` `ChargingStationsFirmwareUpdateUpdateData` Firmware updated
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    chargingStationsFirmwareUpdateUpdate = (
        id: string,
        data: ChargingStationsFirmwareUpdateUpdatePayload,
        params: RequestParams = {}
    ) =>
        this.http.request<ChargingStationsFirmwareUpdateUpdateData, any>({
            path: `/api/charging-stations/${id}/firmware/update`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Update Charging Station availability
     *
     * @tags Charging Stations
     * @name ChargingStationsAvailabilityChangeUpdate
     * @request PUT:/api/charging-stations/{id}/availability/change
     * @secure
     * @response `200` `ChargingStationsAvailabilityChangeUpdateData` Return command success status
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    chargingStationsAvailabilityChangeUpdate = (
        id: string,
        data: ChargingStationsAvailabilityChangeUpdatePayload,
        params: RequestParams = {}
    ) =>
        this.http.request<ChargingStationsAvailabilityChangeUpdateData, any>({
            path: `/api/charging-stations/${id}/availability/change`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Generate connector's QRCode
     *
     * @tags Charging Stations
     * @name ChargingStationsConnectorsQrcodeGenerateDetail
     * @request GET:/api/charging-stations/{id}/connectors/{connectorId}/qrcode/generate
     * @secure
     * @response `200` `ChargingStationsConnectorsQrcodeGenerateDetailData` Return genereated QRCode
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    chargingStationsConnectorsQrcodeGenerateDetail = (id: string, connectorId: number, params: RequestParams = {}) =>
        this.http.request<ChargingStationsConnectorsQrcodeGenerateDetailData, any>({
            path: `/api/charging-stations/${id}/connectors/${connectorId}/qrcode/generate`,
            method: "GET",
            secure: true,
            ...params,
        });
    /**
     * @description Download connector QRCode as PDF
     *
     * @tags Charging Stations
     * @name ChargingStationsQrcodeDownloadList
     * @request GET:/api/charging-stations/qrcode/download
     * @secure
     * @response `200` `ChargingStationsQrcodeDownloadListData` Return connector's QRCode as PDF
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    chargingStationsQrcodeDownloadList = (
        query: ChargingStationsQrcodeDownloadListParams,
        params: RequestParams = {}
    ) =>
        this.http.request<ChargingStationsQrcodeDownloadListData, any>({
            path: `/api/charging-stations/qrcode/download`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Get Charging Station OCPP Parameters
     *
     * @tags Charging Stations
     * @name ChargingStationsOcppParametersDetail
     * @request GET:/api/charging-stations/{id}/ocpp/parameters
     * @secure
     * @response `200` `ChargingStationsOcppParametersDetailData` Return Charging Station OCPP Parameters
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    chargingStationsOcppParametersDetail = (id: string, params: RequestParams = {}) =>
        this.http.request<ChargingStationsOcppParametersDetailData, any>({
            path: `/api/charging-stations/${id}/ocpp/parameters`,
            method: "GET",
            secure: true,
            ...params,
        });
    /**
     * @description Request Charging Station OCPP Parameters
     *
     * @tags Charging Stations
     * @name ChargingStationsOcppParametersCreate
     * @request POST:/api/charging-stations/ocpp/parameters
     * @secure
     * @response `200` `ChargingStationsOcppParametersCreateData` Return command success status
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    chargingStationsOcppParametersCreate = (
        data: ChargingStationsOcppParametersCreatePayload,
        params: RequestParams = {}
    ) =>
        this.http.request<ChargingStationsOcppParametersCreateData, any>({
            path: `/api/charging-stations/ocpp/parameters`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Export Charging Station OCPP Parameters as CSV file
     *
     * @tags Charging Stations
     * @name ChargingStationsOcppParametersExportList
     * @request GET:/api/charging-stations/ocpp/parameters/export
     * @secure
     * @response `200` `ChargingStationsOcppParametersExportListData` Return Charging Station OCPP Parameters CSV file
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    chargingStationsOcppParametersExportList = (
        query: ChargingStationsOcppParametersExportListParams,
        params: RequestParams = {}
    ) =>
        this.http.request<ChargingStationsOcppParametersExportListData, any>({
            path: `/api/charging-stations/ocpp/parameters/export`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Update Charging Station parameters
     *
     * @tags Charging Stations
     * @name ChargingStationsParametersUpdate
     * @request PUT:/api/charging-stations/{id}/parameters
     * @secure
     * @response `200` `ChargingStationsParametersUpdateData` Updated Charging Station parameters with success
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     * @response `539` `void` Site area is single phased.
     */
    chargingStationsParametersUpdate = (
        id: string,
        data: ChargingStationsParametersUpdatePayload,
        params: RequestParams = {}
    ) =>
        this.http.request<ChargingStationsParametersUpdateData, void>({
            path: `/api/charging-stations/${id}/parameters`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Limit Charging Station power
     *
     * @tags Charging Stations
     * @name ChargingStationsPowerLimitUpdate
     * @request PUT:/api/charging-stations/{id}/power/limit
     * @secure
     * @response `200` `ChargingStationsPowerLimitUpdateData` Updated Charging Station power limit with success
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     * @response `556` `void` Cannot set the limit power to the given value
     * @response `585` `any`
     */
    chargingStationsPowerLimitUpdate = (
        id: string,
        data: ChargingStationsPowerLimitUpdatePayload,
        params: RequestParams = {}
    ) =>
        this.http.request<ChargingStationsPowerLimitUpdateData, void>({
            path: `/api/charging-stations/${id}/power/limit`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Get Charging Station transactions
     *
     * @tags Charging Stations
     * @name ChargingStationsTransactionsDetail
     * @request GET:/api/charging-stations/{id}/transactions
     * @secure
     * @response `200` `ChargingStationsTransactionsDetailData` Return Charging Station transactions list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    chargingStationsTransactionsDetail = (
        { id, ...query }: ChargingStationsTransactionsDetailParams,
        params: RequestParams = {}
    ) =>
        this.http.request<ChargingStationsTransactionsDetailData, any>({
            path: `/api/charging-stations/${id}/transactions`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Get Charging Station in error
     *
     * @tags Charging Stations
     * @name ChargingStationsStatusInErrorList
     * @request GET:/api/charging-stations/status/in-error
     * @secure
     * @response `200` `ChargingStationsStatusInErrorListData` Return Charging Stations in error list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    chargingStationsStatusInErrorList = (query: ChargingStationsStatusInErrorListParams, params: RequestParams = {}) =>
        this.http.request<ChargingStationsStatusInErrorListData, any>({
            path: `/api/charging-stations/status/in-error`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Export Charging Stations as CSV file
     *
     * @tags Charging Stations
     * @name ChargingStationsActionExportList
     * @request GET:/api/charging-stations/action/export
     * @secure
     * @response `200` `ChargingStationsActionExportListData` Return Charging Station CSV file
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    chargingStationsActionExportList = (query: ChargingStationsActionExportListParams, params: RequestParams = {}) =>
        this.http.request<ChargingStationsActionExportListData, any>({
            path: `/api/charging-stations/action/export`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Check smart charging connection
     *
     * @tags Charging Stations
     * @name ChargingStationsSmartchargingConnectionCheckList
     * @request GET:/api/charging-stations/smartcharging/connection/check
     * @secure
     * @response `200` `ChargingStationsSmartchargingConnectionCheckListData` Smart Charging is enabled
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    chargingStationsSmartchargingConnectionCheckList = (params: RequestParams = {}) =>
        this.http.request<ChargingStationsSmartchargingConnectionCheckListData, any>({
            path: `/api/charging-stations/smartcharging/connection/check`,
            method: "GET",
            secure: true,
            ...params,
        });
    /**
     * @description Trigger smart charging
     *
     * @tags Charging Stations
     * @name ChargingStationsSmartchargingTriggerList
     * @request GET:/api/charging-stations/smartcharging/trigger
     * @secure
     * @response `200` `ChargingStationsSmartchargingTriggerListData` Smart Charging triggered successfully on site area
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    chargingStationsSmartchargingTriggerList = (
        query: ChargingStationsSmartchargingTriggerListParams,
        params: RequestParams = {}
    ) =>
        this.http.request<ChargingStationsSmartchargingTriggerListData, any>({
            path: `/api/charging-stations/smartcharging/trigger`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Get Charging Stations boot notifications
     *
     * @tags Charging Stations
     * @name ChargingStationsNotificationsBootList
     * @request GET:/api/charging-stations/notifications/boot
     * @secure
     * @response `200` `ChargingStationsNotificationsBootListData` Return the boot notification list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    chargingStationsNotificationsBootList = (
        query: ChargingStationsNotificationsBootListParams,
        params: RequestParams = {}
    ) =>
        this.http.request<ChargingStationsNotificationsBootListData, any>({
            path: `/api/charging-stations/notifications/boot`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Get Charging Stations status notifications
     *
     * @tags Charging Stations
     * @name ChargingStationsNotificationsStatusList
     * @request GET:/api/charging-stations/notifications/status
     * @secure
     * @response `200` `ChargingStationsNotificationsStatusListData` Return the status notification list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    chargingStationsNotificationsStatusList = (
        query: ChargingStationsNotificationsStatusListParams,
        params: RequestParams = {}
    ) =>
        this.http.request<ChargingStationsNotificationsStatusListData, any>({
            path: `/api/charging-stations/notifications/status`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Get Charging Profiles
     *
     * @tags Charging Profiles
     * @name ChargingProfilesList
     * @request GET:/api/charging-profiles
     * @secure
     * @response `200` `ChargingProfilesListData` Return profiles list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    chargingProfilesList = (query: ChargingProfilesListParams, params: RequestParams = {}) =>
        this.http.request<ChargingProfilesListData, any>({
            path: `/api/charging-profiles`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Create a Charging Station profile
     *
     * @tags Charging Profiles
     * @name ChargingProfilesCreate
     * @request POST:/api/charging-profiles
     * @secure
     * @response `201` `ChargingProfilesCreateData` Charging station profile created successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     * @response `585` `any`
     */
    chargingProfilesCreate = (data: ChargingProfile, params: RequestParams = {}) =>
        this.http.request<ChargingProfilesCreateData, any>({
            path: `/api/charging-profiles`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Update a Charging Station profile
     *
     * @tags Charging Profiles
     * @name ChargingProfilesUpdate
     * @request PUT:/api/charging-profiles/{id}
     * @secure
     * @response `200` `ChargingProfilesUpdateData` Charging station profile updated successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     * @response `585` `any`
     */
    chargingProfilesUpdate = (id: string, data: ChargingProfile, params: RequestParams = {}) =>
        this.http.request<ChargingProfilesUpdateData, any>({
            path: `/api/charging-profiles/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Delete a Charging Station profile
     *
     * @tags Charging Profiles
     * @name ChargingProfilesDelete
     * @request DELETE:/api/charging-profiles/{id}
     * @secure
     * @response `200` `ChargingProfilesDeleteData` Charging Station deleted successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     * @response `537` `void` Error occured while clearing Charging Profile
     */
    chargingProfilesDelete = (id: string, params: RequestParams = {}) =>
        this.http.request<ChargingProfilesDeleteData, void>({
            path: `/api/charging-profiles/${id}`,
            method: "DELETE",
            secure: true,
            ...params,
        });
    /**
     * @description Retrieve a list of Users
     *
     * @tags Users
     * @name UsersList
     * @request GET:/api/users
     * @secure
     * @response `200` `UsersListData` Return users list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    usersList = (query: UsersListParams, params: RequestParams = {}) =>
        this.http.request<UsersListData, any>({
            path: `/api/users`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Create a User
     *
     * @tags Users
     * @name UsersCreate
     * @request POST:/api/users
     * @secure
     * @response `201` `UsersCreateData` User created successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     * @response `510` `any`
     */
    usersCreate = (data: User, params: RequestParams = {}) =>
        this.http.request<UsersCreateData, any>({
            path: `/api/users`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Retrieve a User
     *
     * @tags Users
     * @name UsersDetail
     * @request GET:/api/users/{id}
     * @secure
     * @response `200` `UsersDetailData` Retrieved user
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    usersDetail = ({ id, ...query }: UsersDetailParams, params: RequestParams = {}) =>
        this.http.request<UsersDetailData, any>({
            path: `/api/users/${id}`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Update a User
     *
     * @tags Users
     * @name UsersUpdate
     * @request PUT:/api/users/{id}
     * @secure
     * @response `200` `UsersUpdateData` User updated successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     * @response `510` `any`
     */
    usersUpdate = (id: string, data: UsersUpdatePayload, params: RequestParams = {}) =>
        this.http.request<UsersUpdateData, any>({
            path: `/api/users/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Delete a User
     *
     * @tags Users
     * @name UsersDelete
     * @request DELETE:/api/users/{id}
     * @secure
     * @response `200` `UsersDeleteData` User deleted successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     * @response `510` `void` User cannot be deleted due to billing constraints
     */
    usersDelete = (id: string, params: RequestParams = {}) =>
        this.http.request<UsersDeleteData, void>({
            path: `/api/users/${id}`,
            method: "DELETE",
            secure: true,
            ...params,
        });
    /**
     * @description Get the User's default car tag
     *
     * @tags Users
     * @name UsersDefaultCarTagDetail
     * @request GET:/api/users/{id}/default-car-tag
     * @secure
     * @response `200` `UsersDefaultCarTagDetailData` Retrieved default car tag and car
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    usersDefaultCarTagDetail = (id: string, params: RequestParams = {}) =>
        this.http.request<UsersDefaultCarTagDetailData, any>({
            path: `/api/users/${id}/default-car-tag`,
            method: "GET",
            secure: true,
            ...params,
        });
    /**
     * @description Get the User's session context
     *
     * @tags Users
     * @name UsersSessionContextDetail
     * @request GET:/api/users/{id}/session-context
     * @secure
     * @response `200` `UsersSessionContextDetailData` Retrieved user session context
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    usersSessionContextDetail = ({ id, ...query }: UsersSessionContextDetailParams, params: RequestParams = {}) =>
        this.http.request<UsersSessionContextDetailData, any>({
            path: `/api/users/${id}/session-context`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Get user's assigned sites
     *
     * @tags Users
     * @name UsersSitesDetail
     * @request GET:/api/users/{id}/sites
     * @secure
     * @response `200` `UsersSitesDetailData` Retrieved assigned sites list
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    usersSitesDetail = (id: string, params: RequestParams = {}) =>
        this.http.request<UsersSitesDetailData, any>({
            path: `/api/users/${id}/sites`,
            method: "GET",
            secure: true,
            ...params,
        });
    /**
     * @description Assign sites to a user
     *
     * @tags Users
     * @name UsersSitesCreate
     * @request POST:/api/users/{id}/sites
     * @secure
     * @response `200` `UsersSitesCreateData` User successfully assigned to sites
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    usersSitesCreate = (id: string, data: UsersSitesCreatePayload, params: RequestParams = {}) =>
        this.http.request<UsersSitesCreateData, any>({
            path: `/api/users/${id}/sites`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Unassign sites to a user
     *
     * @tags Users
     * @name UsersSitesUpdate
     * @request PUT:/api/users/{id}/sites
     * @secure
     * @response `200` `UsersSitesUpdateData` User successfully unassigned to sites
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    usersSitesUpdate = (id: string, data: UsersSitesUpdatePayload, params: RequestParams = {}) =>
        this.http.request<UsersSitesUpdateData, any>({
            path: `/api/users/${id}/sites`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Update user's mobile data
     *
     * @tags Users
     * @name UsersMobileDataUpdate
     * @request PUT:/api/users/{id}/mobile-data
     * @secure
     * @response `200` `UsersMobileDataUpdateData` Mobile token successfully updated
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    usersMobileDataUpdate = (id: string, data: UsersMobileDataUpdatePayload, params: RequestParams = {}) =>
        this.http.request<UsersMobileDataUpdateData, any>({
            path: `/api/users/${id}/mobile-data`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Get user's image
     *
     * @tags Users
     * @name UsersImageDetail
     * @request GET:/api/users/{id}/image
     * @secure
     * @response `200` `UsersImageDetailData` Retrieved user image
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    usersImageDetail = async (id: string, params: RequestParams = {}) => {
        const tmp = await this.http.request<ArrayBuffer, any>({
            path: `/api/users/${id}/image`,
            method: "GET",
            secure: true,
            ...params,
        });
        return new Blob([tmp], { type: "image/jpeg" });
    };
    /**
     * @description Retrieve a list of Users in error
     *
     * @tags Users
     * @name UsersStatusInErrorList
     * @request GET:/api/users/status/in-error
     * @secure
     * @response `200` `UsersStatusInErrorListData` Return users in error list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    usersStatusInErrorList = (query: UsersStatusInErrorListParams, params: RequestParams = {}) =>
        this.http.request<UsersStatusInErrorListData, any>({
            path: `/api/users/status/in-error`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Import users from file
     *
     * @tags Users
     * @name UsersActionImportCreate
     * @request POST:/api/users/action/import
     * @secure
     * @response `200` `UsersActionImportCreateData` Users importation results
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     * @response `583` `any`
     * @response `584` `any`
     */
    usersActionImportCreate = (data: UsersActionImportCreatePayload, params: RequestParams = {}) =>
        this.http.request<UsersActionImportCreateData, any>({
            path: `/api/users/action/import`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.FormData,
            ...params,
        });
    /**
     * @description Export users
     *
     * @tags Users
     * @name UsersActionExportList
     * @request GET:/api/users/action/export
     * @secure
     * @response `200` `UsersActionExportListData` Users exported successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     * @response `583` `void` Invalid file format
     * @response `584` `void` Invalid CSV header format
     */
    usersActionExportList = (query: UsersActionExportListParams, params: RequestParams = {}) =>
        this.http.request<UsersActionExportListData, void>({
            path: `/api/users/action/export`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Get pricing definitions
     *
     * @tags Pricing
     * @name PricingDefinitionsList
     * @request GET:/api/pricing-definitions
     * @secure
     * @response `200` `PricingDefinitionsListData` Return pricing definitions
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    pricingDefinitionsList = (query: PricingDefinitionsListParams, params: RequestParams = {}) =>
        this.http.request<PricingDefinitionsListData, any>({
            path: `/api/pricing-definitions`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Get pricing definition by id
     *
     * @tags Pricing
     * @name PricingDefinitionsDetail
     * @request GET:/api/pricing-definitions/{id}
     * @secure
     * @response `200` `PricingDefinitionsDetailData` Return pricing definition
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    pricingDefinitionsDetail = (id: string, params: RequestParams = {}) =>
        this.http.request<PricingDefinitionsDetailData, any>({
            path: `/api/pricing-definitions/${id}`,
            method: "GET",
            secure: true,
            ...params,
        });
    /**
     * @description Resolve pricing context
     *
     * @tags Pricing
     * @name PricingModelResolveList
     * @request GET:/api/pricing-model/resolve
     * @secure
     * @response `200` `PricingModelResolveListData` Return tariffs matching a pricing context
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    pricingModelResolveList = (query: PricingModelResolveListParams, params: RequestParams = {}) =>
        this.http.request<PricingModelResolveListData, any>({
            path: `/api/pricing-model/resolve`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Get user's payment methods
     *
     * @tags Billing
     * @name UsersPaymentMethodsDetail
     * @request GET:/api/users/{id}/payment-methods
     * @secure
     * @response `200` `UsersPaymentMethodsDetailData` Retrieved user payment methods
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    usersPaymentMethodsDetail = ({ id, ...query }: UsersPaymentMethodsDetailParams, params: RequestParams = {}) =>
        this.http.request<UsersPaymentMethodsDetailData, any>({
            path: `/api/users/${id}/payment-methods?Limit=1000`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Delete user's payment methods
     *
     * @tags Billing
     * @name UsersPaymentMethodsDelete
     * @request DELETE:/api/users/{id}/payment-methods/{paymentMethodID}
     * @secure
     * @response `200` `UsersPaymentMethodsDeleteData` Successfully deleted user payment method
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    usersPaymentMethodsDelete = (id: string, paymentMethodId: string, params: RequestParams = {}) =>
        this.http.request<UsersPaymentMethodsDeleteData, any>({
            path: `/api/users/${id}/payment-methods/${paymentMethodId}`,
            method: "DELETE",
            secure: true,
            ...params,
        });
    /**
     * @description Setup user's payment method
     *
     * @tags Billing
     * @name UsersPaymentMethodsSetupCreate
     * @request POST:/api/users/{id}/payment-methods/setup
     * @secure
     * @response `200` `UsersPaymentMethodsSetupCreateData` Successfully setup user payment method
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    usersPaymentMethodsSetupCreate = (
        id: string,
        data: UsersPaymentMethodsSetupCreatePayload,
        params: RequestParams = {}
    ) =>
        this.http.request<UsersPaymentMethodsSetupCreateData, any>({
            path: `/api/users/${id}/payment-methods/setup`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Retrieve a list of Tags
     *
     * @tags Tags
     * @name TagsList
     * @request GET:/api/tags
     * @secure
     * @response `200` `TagsListData` Return tags list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    tagsList = (query: TagsListParams, params: RequestParams = {}) =>
        this.http.request<TagsListData, any>({
            path: `/api/tags`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Create a Tag
     *
     * @tags Tags
     * @name TagsCreate
     * @request POST:/api/tags
     * @secure
     * @response `201` `TagsCreateData` Tag created successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `void` User does not exist
     * @response `500` `any`
     * @response `576` `void` Tag already exists
     */
    tagsCreate = (data: Tag, params: RequestParams = {}) =>
        this.http.request<TagsCreateData, void>({
            path: `/api/tags`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Delete several Tags
     *
     * @tags Tags
     * @name TagsDelete
     * @request DELETE:/api/tags
     * @secure
     * @response `200` `TagsDeleteData` Tags deletion result
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    tagsDelete = (data: TagsDeletePayload, params: RequestParams = {}) =>
        this.http.request<TagsDeleteData, any>({
            path: `/api/tags`,
            method: "DELETE",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Retrieve a Tag
     *
     * @tags Tags
     * @name TagsDetail
     * @request GET:/api/tags/{id}
     * @secure
     * @response `200` `TagsDetailData` Return tag
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    tagsDetail = ({ id, ...query }: TagsDetailParams, params: RequestParams = {}) =>
        this.http.request<TagsDetailData, any>({
            path: `/api/tags/${id}`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Update a Tag
     *
     * @tags Tags
     * @name TagsUpdate
     * @request PUT:/api/tags/{id}
     * @secure
     * @response `200` `TagsUpdateData` Tag updated successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     * @response `575` `any`
     */
    tagsUpdate = (id: string, data: TagsUpdatePayload, params: RequestParams = {}) =>
        this.http.request<TagsUpdateData, any>({
            path: `/api/tags/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Delete a Tag
     *
     * @tags Tags
     * @name TagsDelete2
     * @request DELETE:/api/tags/{id}
     * @originalName tagsDelete
     * @duplicate
     * @secure
     * @response `200` `TagsDelete2Data` Tag deleted successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    tagsDelete2 = (id: string, params: RequestParams = {}) =>
        this.http.request<TagsDelete2Data, any>({
            path: `/api/tags/${id}`,
            method: "DELETE",
            secure: true,
            ...params,
        });
    /**
     * @description Assign a Tag to a user
     *
     * @tags Tags
     * @name TagsAssignUpdate
     * @request PUT:/api/tags/{id}/assign
     * @secure
     * @response `200` `TagsAssignUpdateData` Tag successfully assigned
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     * @response `576` `void` Tag already exists and assigned to another user
     * @response `578` `void` Tag with given visual ID does not match any badge
     * @response `579` `void` Tag with given visual ID is not active and cannot be assigned
     */
    tagsAssignUpdate = (id: string, data: TagsAssignUpdatePayload, params: RequestParams = {}) =>
        this.http.request<TagsAssignUpdateData, void>({
            path: `/api/tags/${id}/assign`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Unassign a Tag
     *
     * @tags Tags
     * @name TagsUnassignUpdate
     * @request PUT:/api/tags/{id}/unassign
     * @secure
     * @response `200` `TagsUnassignUpdateData` Tag successfully unassigned
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    tagsUnassignUpdate = (id: string, params: RequestParams = {}) =>
        this.http.request<TagsUnassignUpdateData, any>({
            path: `/api/tags/${id}/unassign`,
            method: "PUT",
            secure: true,
            ...params,
        });
    /**
     * @description Unassign several Tags
     *
     * @tags Tags
     * @name TagsUnassignUpdate2
     * @request PUT:/api/tags/unassign
     * @originalName tagsUnassignUpdate
     * @duplicate
     * @secure
     * @response `200` `TagsUnassignUpdate2Data` Tags successfully unassigned
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    tagsUnassignUpdate2 = (data: TagsUnassignUpdate2Payload, params: RequestParams = {}) =>
        this.http.request<TagsUnassignUpdate2Data, any>({
            path: `/api/tags/unassign`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Import a Tag file
     *
     * @tags Tags
     * @name TagsActionImportCreate
     * @request POST:/api/tags/action/import
     * @secure
     * @response `200` `TagsActionImportCreateData` Tag importation results
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     * @response `583` `any`
     * @response `584` `any`
     */
    tagsActionImportCreate = (data: TagsActionImportCreatePayload, params: RequestParams = {}) =>
        this.http.request<TagsActionImportCreateData, any>({
            path: `/api/tags/action/import`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.FormData,
            ...params,
        });
    /**
     * @description Export Tags
     *
     * @tags Tags
     * @name TagsActionExportList
     * @request GET:/api/tags/action/export
     * @secure
     * @response `200` `TagsActionExportListData` Return exported tags
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     * @response `583` `any`
     * @response `584` `any`
     */
    tagsActionExportList = (query: TagsActionExportListParams, params: RequestParams = {}) =>
        this.http.request<TagsActionExportListData, any>({
            path: `/api/tags/action/export`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Retrieve a list of notifications
     *
     * @tags Notifications
     * @name NotificationsList
     * @request GET:/api/notifications
     * @secure
     * @response `200` `NotificationsListData` Return notification list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    notificationsList = (query: NotificationsListParams, params: RequestParams = {}) =>
        this.http.request<NotificationsListData, any>({
            path: `/api/notifications`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Report an error
     *
     * @tags Notifications
     * @name NotificationsActionEndUserReportErrorCreate
     * @request POST:/api/notifications/action/end-user/report-error
     * @secure
     * @response `200` `NotificationsActionEndUserReportErrorCreateData` Error reported successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    notificationsActionEndUserReportErrorCreate = (
        data: NotificationsActionEndUserReportErrorCreatePayload,
        params: RequestParams = {}
    ) =>
        this.http.request<NotificationsActionEndUserReportErrorCreateData, any>({
            path: `/api/notifications/action/end-user/report-error`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Retrieve a list of Sites
     *
     * @tags Sites
     * @name SitesList
     * @request GET:/api/sites
     * @response `200` `SitesListData` Return site list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    sitesList = (query: SitesListParams, params: RequestParams = {}) =>
        this.http.request<SitesListData, any>({
            path: `/api/sites`,
            method: "GET",
            query: query,
            ...params,
        });
    /**
     * @description Create a Site
     *
     * @tags Sites
     * @name SitesCreate
     * @request POST:/api/sites
     * @response `200` `SitesCreateData` Site has been created with success
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    sitesCreate = (data: Site, params: RequestParams = {}) =>
        this.http.request<SitesCreateData, any>({
            path: `/api/sites`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Retrieve a site
     *
     * @tags Sites
     * @name SitesDetail
     * @request GET:/api/sites/{id}
     * @response `200` `SitesDetailData` Return site
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    sitesDetail = (id: string, params: RequestParams = {}) =>
        this.http.request<SitesDetailData, any>({
            path: `/api/sites/${id}`,
            method: "GET",
            ...params,
        });
    /**
     * @description Update a Site
     *
     * @tags Sites
     * @name SitesUpdate
     * @request PUT:/api/sites/{id}
     * @secure
     * @response `200` `SitesUpdateData` Site updated successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     * @response `585` `void` Cannot set site to private as one or several charging stations under site are public
     */
    sitesUpdate = (id: string, data: Site, params: RequestParams = {}) =>
        this.http.request<SitesUpdateData, void>({
            path: `/api/sites/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Delete a site
     *
     * @tags Sites
     * @name SitesDelete
     * @request DELETE:/api/sites/{id}
     * @response `200` `SitesDeleteData` Site deleted successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    sitesDelete = (id: string, params: RequestParams = {}) =>
        this.http.request<SitesDeleteData, any>({
            path: `/api/sites/${id}`,
            method: "DELETE",
            ...params,
        });
    /**
     * @description Retrieve site's users
     *
     * @tags Sites
     * @name SitesUsersDetail
     * @request GET:/api/sites/{id}/users
     * @response `200` `SitesUsersDetailData` Return site's user list
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    sitesUsersDetail = (id: string, query?: { Limit?: number; SiteID?: string }, params: RequestParams = {}) =>
        this.http.request<SitesUsersDetailData, any>({
            path: `/api/sites/${id}/users`,
            query,
            method: "GET",
            ...params,
        });
    /**
     * @description Assign users to a site
     *
     * @tags Sites
     * @name SitesAssignUpdate
     * @request PUT:/api/sites/{id}/assign
     * @response `200` `SitesAssignUpdateData` Users successfully assigned
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    sitesAssignUpdate = (id: string, data: SitesAssignUpdatePayload, params: RequestParams = {}) =>
        this.http.request<SitesAssignUpdateData, any>({
            path: `/api/sites/${id}/users/assign`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Unassign users from a site
     *
     * @tags Sites
     * @name SitesUnassignUpdate
     * @request PUT:/api/sites/{id}/unassign
     * @response `200` `SitesUnassignUpdateData` Users successfully unassigned
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    sitesUnassignUpdate = (id: string, data: SitesUnassignUpdatePayload, params: RequestParams = {}) =>
        this.http.request<SitesUnassignUpdateData, any>({
            path: `/api/sites/${id}/users/unassign`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Set user as site admin
     *
     * @tags Sites
     * @name SitesUsersAdminUpdate
     * @request PUT:/api/sites/{id}/users/admin
     * @response `200` `SitesUsersAdminUpdateData` User successfully set/unset as site admin
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    sitesUsersAdminUpdate = (id: string, data: SitesUsersAdminUpdatePayload, params: RequestParams = {}) =>
        this.http.request<SitesUsersAdminUpdateData, any>({
            path: `/api/sites/${id}/users/admin`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Set user as site owner
     *
     * @tags Sites
     * @name SitesUsersOwnerUpdate
     * @request PUT:/api/sites/{id}/users/owner
     * @response `200` `SitesUsersOwnerUpdateData` User successfully set/unset as site owner
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    sitesUsersOwnerUpdate = (id: string, data: SitesUsersOwnerUpdatePayload, params: RequestParams = {}) =>
        this.http.request<SitesUsersOwnerUpdateData, any>({
            path: `/api/sites/${id}/users/owner`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Retrieve a list of logs
     *
     * @tags Logs
     * @name LogsList
     * @request GET:/api/logs
     * @secure
     * @response `200` `LogsListData` Return logs list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    logsList = (query: LogsListParams, params: RequestParams = {}) =>
        this.http.request<LogsListData, any>({
            path: `/api/logs`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Retrieve a log
     *
     * @tags Logs
     * @name LogsDetail
     * @request GET:/api/logs/{id}
     * @secure
     * @response `200` `LogsDetailData` Returned log
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    logsDetail = (id: string, params: RequestParams = {}) =>
        this.http.request<LogsDetailData, any>({
            path: `/api/logs/${id}`,
            method: "GET",
            secure: true,
            ...params,
        });
    /**
     * @description Export logs as CSV file
     *
     * @tags Logs
     * @name LogsActionExportList
     * @request GET:/api/logs/action/export
     * @secure
     * @response `200` `LogsActionExportListData` Return exported logs
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    logsActionExportList = (query: LogsActionExportListParams, params: RequestParams = {}) =>
        this.http.request<LogsActionExportListData, any>({
            path: `/api/logs/action/export`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Get integration connections
     *
     * @tags Connections
     * @name ConnectionsList
     * @request GET:/api/connections
     * @secure
     * @response `200` `ConnectionsListData` Return connections list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    connectionsList = (query: ConnectionsListParams, params: RequestParams = {}) =>
        this.http.request<ConnectionsListData, any>({
            path: `/api/connections`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Create an integration connection
     *
     * @tags Connections
     * @name ConnectionsCreate
     * @request POST:/api/connections
     * @secure
     * @response `200` `ConnectionsCreateData` Connection created successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    connectionsCreate = (data: ConnectionsCreatePayload, params: RequestParams = {}) =>
        this.http.request<ConnectionsCreateData, any>({
            path: `/api/connections`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Get integration connection
     *
     * @tags Connections
     * @name ConnectionsDetail
     * @request GET:/api/connections/{id}
     * @secure
     * @response `200` `ConnectionsDetailData` Return connection
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    connectionsDetail = (id: string, params: RequestParams = {}) =>
        this.http.request<ConnectionsDetailData, any>({
            path: `/api/connections/${id}`,
            method: "GET",
            secure: true,
            ...params,
        });
    /**
     * @description Delete an integration connection
     *
     * @tags Connections
     * @name ConnectionsDelete
     * @request DELETE:/api/connections/{id}
     * @secure
     * @response `200` `ConnectionsDeleteData` Connection successfully deleted
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    connectionsDelete = (id: string, params: RequestParams = {}) =>
        this.http.request<ConnectionsDeleteData, any>({
            path: `/api/connections/${id}`,
            method: "DELETE",
            secure: true,
            ...params,
        });
    /**
     * @description Get car catalogs list
     *
     * @tags Cars
     * @name CarCatalogsList
     * @request GET:/api/car-catalogs
     * @secure
     * @response `200` `CarCatalogsListData` Return car catalogs list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    carCatalogsList = (query: CarCatalogsListParams, params: RequestParams = {}) =>
        this.http.request<CarCatalogsListData, any>({
            path: `/api/car-catalogs`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Get car catalog
     *
     * @tags Cars
     * @name CarCatalogsDetail
     * @request GET:/api/car-catalogs/{id}
     * @secure
     * @response `200` `CarCatalogsDetailData` Return car catalog
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    carCatalogsDetail = ({ id, ...query }: CarCatalogsDetailParams, params: RequestParams = {}) =>
        this.http.request<CarCatalogsDetailData, any>({
            path: `/api/car-catalogs/${id}`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Get car catalog images
     *
     * @tags Cars
     * @name CarCatalogsImagesDetail
     * @request GET:/api/car-catalogs/{id}/images
     * @secure
     * @response `200` `CarCatalogsImagesDetailData` Return car catalog images
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    carCatalogsImagesDetail = ({ id, ...query }: CarCatalogsImagesDetailParams, params: RequestParams = {}) =>
        this.http.request<CarCatalogsImagesDetailData, any>({
            path: `/api/car-catalogs/${id}/images`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Synchronize car catalogs
     *
     * @tags Cars
     * @name CarCatalogsActionSynchronizeCreate
     * @request POST:/api/car-catalogs/action/synchronize
     * @secure
     * @response `200` `CarCatalogsActionSynchronizeCreateData` Return car catalogs list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    carCatalogsActionSynchronizeCreate = (params: RequestParams = {}) =>
        this.http.request<CarCatalogsActionSynchronizeCreateData, any>({
            path: `/api/car-catalogs/action/synchronize`,
            method: "POST",
            secure: true,
            ...params,
        });
    /**
     * @description Get car makers list
     *
     * @tags Cars
     * @name CarMakersList
     * @request GET:/api/car-makers
     * @secure
     * @response `200` `CarMakersListData` Return car makers list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    carMakersList = (query: CarMakersListParams, params: RequestParams = {}) =>
        this.http.request<CarMakersListData, any>({
            path: `/api/car-makers`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Get cars list
     *
     * @tags Cars
     * @name CarsList
     * @request GET:/api/cars
     * @secure
     * @response `200` `CarsListData` Return cars list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    carsList = (query: CarsListParams, params: RequestParams = {}) =>
        this.http.request<CarsListData, any>({
            path: `/api/cars`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Create car
     *
     * @tags Cars
     * @name CarsCreate
     * @request POST:/api/cars
     * @secure
     * @response `200` `CarsCreateData` Car successfully created
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     * @response `591` `void` The Car with the given VIN and given License plate already exists
     */
    carsCreate = (data: Car, params: RequestParams = {}) =>
        this.http.request<CarsCreateData, void>({
            path: `/api/cars`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Get car
     *
     * @tags Cars
     * @name CarsDetail
     * @request GET:/api/cars/{id}
     * @secure
     * @response `200` `CarsDetailData` Return car
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    carsDetail = ({ id, ...query }: CarsDetailParams, params: RequestParams = {}) =>
        this.http.request<CarsDetailData, any>({
            path: `/api/cars/${id}`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Create car
     *
     * @tags Cars
     * @name CarsCreate2
     * @request POST:/api/cars/{id}
     * @originalName carsCreate
     * @duplicate
     * @secure
     * @response `200` `CarsCreate2Data` Car successfully created
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     * @response `591` `void` The Car with the given VIN and given License plate already exists
     */
    carsCreate2 = (id: string, data: Car, params: RequestParams = {}) =>
        this.http.request<CarsCreate2Data, void>({
            path: `/api/cars/${id}`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Update a car
     *
     * @tags Cars
     * @name CarsUpdate
     * @request PUT:/api/cars/{id}
     * @secure
     * @response `200` `CarsUpdateData` Car successfully updated
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     * @response `591` `void` The Car with the given VIN and given License plate already exists
     */
    carsUpdate = ({ id, ...query }: CarsUpdateParams, data: Car, params: RequestParams = {}) =>
        this.http.request<CarsUpdateData, void>({
            path: `/api/cars/${id}`,
            method: "PUT",
            query: query,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Delete a car
     *
     * @tags Cars
     * @name CarsDelete
     * @request DELETE:/api/cars/{id}
     * @secure
     * @response `200` `CarsDeleteData` Car successfully deleted
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    carsDelete = ({ id, ...query }: CarsDeleteParams, params: RequestParams = {}) =>
        this.http.request<CarsDeleteData, any>({
            path: `/api/cars/${id}`,
            method: "DELETE",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Get assets list
     *
     * @tags Assets
     * @name AssetsList
     * @request GET:/api/assets
     * @secure
     * @response `200` `AssetsListData` Return assets list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    assetsList = (query: AssetsListParams, params: RequestParams = {}) =>
        this.http.request<AssetsListData, any>({
            path: `/api/assets`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Create an Asset
     *
     * @tags Assets
     * @name AssetsCreate
     * @request POST:/api/assets
     * @secure
     * @response `200` `AssetsCreateData` Asset created successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    assetsCreate = (data: Asset, params: RequestParams = {}) =>
        this.http.request<AssetsCreateData, any>({
            path: `/api/assets`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Get asset
     *
     * @tags Assets
     * @name AssetsDetail
     * @request GET:/api/assets/{id}
     * @secure
     * @response `200` `AssetsDetailData` Return asset
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    assetsDetail = ({ id, ...query }: AssetsDetailParams, params: RequestParams = {}) =>
        this.http.request<AssetsDetailData, any>({
            path: `/api/assets/${id}`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Update an Asset
     *
     * @tags Assets
     * @name AssetsUpdate
     * @request PUT:/api/assets/{id}
     * @secure
     * @response `200` `AssetsUpdateData` Asset updated successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    assetsUpdate = (id: string, data: Asset, params: RequestParams = {}) =>
        this.http.request<AssetsUpdateData, any>({
            path: `/api/assets/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Delete an Asset
     *
     * @tags Assets
     * @name AssetsDelete
     * @request DELETE:/api/assets/{id}
     * @secure
     * @response `200` `AssetsDeleteData` Asset deleted successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    assetsDelete = (id: string, params: RequestParams = {}) =>
        this.http.request<AssetsDeleteData, any>({
            path: `/api/assets/${id}`,
            method: "DELETE",
            secure: true,
            ...params,
        });
    /**
     * @description Get assets in error list
     *
     * @tags Assets
     * @name AssetsStatusInErrorList
     * @request GET:/api/assets/status/in-error
     * @secure
     * @response `200` `AssetsStatusInErrorListData` Return assets in error list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    assetsStatusInErrorList = (query: AssetsStatusInErrorListParams, params: RequestParams = {}) =>
        this.http.request<AssetsStatusInErrorListData, any>({
            path: `/api/assets/status/in-error`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Check the asset connection
     *
     * @tags Assets
     * @name AssetsConnectorsConnectionCheckDetail
     * @request GET:/api/assets/connectors/{id}/connection/check
     * @secure
     * @response `200` `AssetsConnectorsConnectionCheckDetailData` Return asset connection status
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    assetsConnectorsConnectionCheckDetail = (
        { id, ...query }: AssetsConnectorsConnectionCheckDetailParams,
        params: RequestParams = {}
    ) =>
        this.http.request<AssetsConnectorsConnectionCheckDetailData, any>({
            path: `/api/assets/connectors/${id}/connection/check`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Retrieve the asset last consumption
     *
     * @tags Assets
     * @name AssetsConnectorConsumptionRetrieveLastDetail
     * @request GET:/api/assets/{id}/connector/consumption/retrieve-last
     * @secure
     * @response `200` `AssetsConnectorConsumptionRetrieveLastDetailData` Asset's last consumption retrieved
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    assetsConnectorConsumptionRetrieveLastDetail = (id: string, params: RequestParams = {}) =>
        this.http.request<AssetsConnectorConsumptionRetrieveLastDetailData, any>({
            path: `/api/assets/${id}/connector/consumption/retrieve-last`,
            method: "GET",
            secure: true,
            ...params,
        });
    /**
     * @description Get asset's consumptions
     *
     * @tags Assets
     * @name AssetsConsumptionsDetail
     * @request GET:/api/assets/{id}/consumptions
     * @secure
     * @response `200` `AssetsConsumptionsDetailData` Asset's last consumption retrieved
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    assetsConsumptionsDetail = ({ id, ...query }: AssetsConsumptionsDetailParams, params: RequestParams = {}) =>
        this.http.request<AssetsConsumptionsDetailData, any>({
            path: `/api/assets/${id}/consumptions`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Push latest asset consumption
     *
     * @tags Assets
     * @name AssetsConsumptionsCreate
     * @request POST:/api/assets/{id}/consumptions
     * @secure
     * @response `201` `AssetsConsumptionsCreateData` Asset consumption created successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `void` Asset does not exist
     * @response `500` `any`
     */
    assetsConsumptionsCreate = (id: string, data: AssetConsumption, params: RequestParams = {}) =>
        this.http.request<AssetsConsumptionsCreateData, void>({
            path: `/api/assets/${id}/consumptions`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Retrieve a list of Companies
     *
     * @tags Companies
     * @name CompaniesList
     * @request GET:/api/companies
     * @secure
     * @response `200` `CompaniesListData` Return companies list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    companiesList = (query: CompaniesListParams, params: RequestParams = {}) =>
        this.http.request<CompaniesListData, any>({
            path: `/api/companies`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Create a Company
     *
     * @tags Companies
     * @name CompaniesCreate
     * @request POST:/api/companies
     * @secure
     * @response `201` `CompaniesCreateData` Company created successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    companiesCreate = (data: Company, params: RequestParams = {}) =>
        this.http.request<CompaniesCreateData, any>({
            path: `/api/companies`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Retrieve a Company
     *
     * @tags Companies
     * @name CompaniesDetail
     * @request GET:/api/companies/{id}
     * @secure
     * @response `200` `CompaniesDetailData` Return company
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    companiesDetail = (id: string, query: any, params: RequestParams = {}) =>
        this.http.request<CompaniesDetailData, any>({
            path: `/api/companies/${id}`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });

    companiesDetailLogo = (id: string, query: any, params: RequestParams = {}) =>
        this.http.request<CompaniesDetailData, any>({
            path: `/api/companies/${id}/logo`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Update a Company
     *
     * @tags Companies
     * @name CompaniesUpdate
     * @request PUT:/api/companies/{id}
     * @secure
     * @response `201` `CompaniesUpdateData` Company updated successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    companiesUpdate = (id: string, data: Company, params: RequestParams = {}) =>
        this.http.request<CompaniesUpdateData, any>({
            path: `/api/companies/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Delete a Company
     *
     * @tags Companies
     * @name CompaniesDelete
     * @request DELETE:/api/companies/{id}
     * @secure
     * @response `200` `CompaniesDeleteData` Company deleted successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    companiesDelete = (id: string, params: RequestParams = {}) =>
        this.http.request<CompaniesDeleteData, any>({
            path: `/api/companies/${id}`,
            method: "DELETE",
            secure: true,
            ...params,
        });
    /**
     * @description Retrieve a list of OCPI Endpoints
     *
     * @tags OCPI
     * @name OcpiEndpointsList
     * @request GET:/api/ocpi/endpoints
     * @secure
     * @response `200` `OcpiEndpointsListData` Return OCPI Endpoints list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    ocpiEndpointsList = (query: OcpiEndpointsListParams, params: RequestParams = {}) =>
        this.http.request<OcpiEndpointsListData, any>({
            path: `/api/ocpi/endpoints`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Create an OCPI Endpoint
     *
     * @tags OCPI
     * @name OcpiEndpointsCreate
     * @request POST:/api/ocpi/endpoints
     * @secure
     * @response `201` `OcpiEndpointsCreateData` OCPI Endpoint created successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    ocpiEndpointsCreate = (data: OCPIEndpoint, params: RequestParams = {}) =>
        this.http.request<OcpiEndpointsCreateData, any>({
            path: `/api/ocpi/endpoints`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Retrieve an OCPI Endpoint
     *
     * @tags OCPI
     * @name OcpiEndpointsDetail
     * @request GET:/api/ocpi/endpoints/{id}
     * @secure
     * @response `200` `OcpiEndpointsDetailData` Return OCPI Endpoint
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    ocpiEndpointsDetail = (id: string, params: RequestParams = {}) =>
        this.http.request<OcpiEndpointsDetailData, any>({
            path: `/api/ocpi/endpoints/${id}`,
            method: "GET",
            secure: true,
            ...params,
        });
    /**
     * @description Update an OCPI Endpoint
     *
     * @tags OCPI
     * @name OcpiEndpointsUpdate
     * @request PUT:/api/ocpi/endpoints/{id}
     * @secure
     * @response `200` `OcpiEndpointsUpdateData` OCPI Endpoint updated successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    ocpiEndpointsUpdate = (id: string, data: OCPIEndpoint, params: RequestParams = {}) =>
        this.http.request<OcpiEndpointsUpdateData, any>({
            path: `/api/ocpi/endpoints/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Delete an OCPI Endpoint
     *
     * @tags OCPI
     * @name OcpiEndpointsDelete
     * @request DELETE:/api/ocpi/endpoints/{id}
     * @secure
     * @response `200` `OcpiEndpointsDeleteData` OCPI Endpoint deleted
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    ocpiEndpointsDelete = (id: string, params: RequestParams = {}) =>
        this.http.request<OcpiEndpointsDeleteData, any>({
            path: `/api/ocpi/endpoints/${id}`,
            method: "DELETE",
            secure: true,
            ...params,
        });
    /**
     * @description Ping an OCPI Endpoint
     *
     * @tags OCPI
     * @name OcpiEndpointsPingUpdate
     * @request PUT:/api/ocpi/endpoints/{id}/ping
     * @secure
     * @response `200` `OcpiEndpointsPingUpdateData` OCPI Endpoint is reachable
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    ocpiEndpointsPingUpdate = (id: string, data: OCPIEndpoint, params: RequestParams = {}) =>
        this.http.request<OcpiEndpointsPingUpdateData, any>({
            path: `/api/ocpi/endpoints/${id}/ping`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Check OCPI Endpoint's CDRs
     *
     * @tags OCPI
     * @name OcpiEndpointsCdrsCheckUpdate
     * @request PUT:/api/ocpi/endpoints/{id}/cdrs/check
     * @secure
     * @response `200` `OcpiEndpointsCdrsCheckUpdateData` OCPI Endpoint's CDRs checked
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    ocpiEndpointsCdrsCheckUpdate = (id: string, params: RequestParams = {}) =>
        this.http.request<OcpiEndpointsCdrsCheckUpdateData, any>({
            path: `/api/ocpi/endpoints/${id}/cdrs/check`,
            method: "PUT",
            secure: true,
            ...params,
        });
    /**
     * @description Check OCPI Endpoint's locations
     *
     * @tags OCPI
     * @name OcpiEndpointsLocationsCheckUpdate
     * @request PUT:/api/ocpi/endpoints/{id}/locations/check
     * @secure
     * @response `200` `OcpiEndpointsLocationsCheckUpdateData` OCPI Endpoint's locations checked
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    ocpiEndpointsLocationsCheckUpdate = (id: string, params: RequestParams = {}) =>
        this.http.request<OcpiEndpointsLocationsCheckUpdateData, any>({
            path: `/api/ocpi/endpoints/${id}/locations/check`,
            method: "PUT",
            secure: true,
            ...params,
        });
    /**
     * @description Check OCPI Endpoint's sessions
     *
     * @tags OCPI
     * @name OcpiEndpointsSessionsCheckUpdate
     * @request PUT:/api/ocpi/endpoints/{id}/sessions/check
     * @secure
     * @response `200` `OcpiEndpointsSessionsCheckUpdateData` OCPI Endpoint's sessions checked
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    ocpiEndpointsSessionsCheckUpdate = (id: string, params: RequestParams = {}) =>
        this.http.request<OcpiEndpointsSessionsCheckUpdateData, any>({
            path: `/api/ocpi/endpoints/${id}/sessions/check`,
            method: "PUT",
            secure: true,
            ...params,
        });
    /**
     * @description Pull OCPI Endpoint's CDRs
     *
     * @tags OCPI
     * @name OcpiEndpointsCdrsPullUpdate
     * @request PUT:/api/ocpi/endpoints/{id}/cdrs/pull
     * @secure
     * @response `200` `OcpiEndpointsCdrsPullUpdateData` OCPI Endpoint's cdrs pulled
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    ocpiEndpointsCdrsPullUpdate = (id: string, params: RequestParams = {}) =>
        this.http.request<OcpiEndpointsCdrsPullUpdateData, any>({
            path: `/api/ocpi/endpoints/${id}/cdrs/pull`,
            method: "PUT",
            secure: true,
            ...params,
        });
    /**
     * @description Pull OCPI Endpoint's locations
     *
     * @tags OCPI
     * @name OcpiEndpointsLocationsPullUpdate
     * @request PUT:/api/ocpi/endpoints/{id}/locations/pull
     * @secure
     * @response `200` `OcpiEndpointsLocationsPullUpdateData` OCPI Endpoint's locations pulled
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    ocpiEndpointsLocationsPullUpdate = (id: string, params: RequestParams = {}) =>
        this.http.request<OcpiEndpointsLocationsPullUpdateData, any>({
            path: `/api/ocpi/endpoints/${id}/locations/pull`,
            method: "PUT",
            secure: true,
            ...params,
        });
    /**
     * @description Pull OCPI Endpoint's sessions
     *
     * @tags OCPI
     * @name OcpiEndpointsSessionsPullUpdate
     * @request PUT:/api/ocpi/endpoints/{id}/sessions/pull
     * @secure
     * @response `200` `OcpiEndpointsSessionsPullUpdateData` OCPI Endpoint's sessions pulled
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    ocpiEndpointsSessionsPullUpdate = (id: string, params: RequestParams = {}) =>
        this.http.request<OcpiEndpointsSessionsPullUpdateData, any>({
            path: `/api/ocpi/endpoints/${id}/sessions/pull`,
            method: "PUT",
            secure: true,
            ...params,
        });
    /**
     * @description Pull OCPI Endpoint's tokens
     *
     * @tags OCPI
     * @name OcpiEndpointsTokensPullUpdate
     * @request PUT:/api/ocpi/endpoints/{id}/tokens/pull
     * @secure
     * @response `200` `OcpiEndpointsTokensPullUpdateData` OCPI Endpoint's tokens pulled
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    ocpiEndpointsTokensPullUpdate = (id: string, params: RequestParams = {}) =>
        this.http.request<OcpiEndpointsTokensPullUpdateData, any>({
            path: `/api/ocpi/endpoints/${id}/tokens/pull`,
            method: "PUT",
            secure: true,
            ...params,
        });
    /**
     * @description Send OCPI EVSE's statuses
     *
     * @tags OCPI
     * @name OcpiEndpointsEvsesStatusesSendUpdate
     * @request PUT:/api/ocpi/endpoints/{id}/evses/statuses/send
     * @secure
     * @response `200` `OcpiEndpointsEvsesStatusesSendUpdateData` OCPI Endpoint's EVSE's statuses sent
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    ocpiEndpointsEvsesStatusesSendUpdate = (id: string, params: RequestParams = {}) =>
        this.http.request<OcpiEndpointsEvsesStatusesSendUpdateData, any>({
            path: `/api/ocpi/endpoints/${id}/evses/statuses/send`,
            method: "PUT",
            secure: true,
            ...params,
        });
    /**
     * @description Push OCPI Endpoint's tokens
     *
     * @tags OCPI
     * @name OcpiEndpointsTokensSendUpdate
     * @request PUT:/api/ocpi/endpoints/{id}/tokens/send
     * @secure
     * @response `200` `OcpiEndpointsTokensSendUpdateData` OCPI Endpoint's tokens pushed
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    ocpiEndpointsTokensSendUpdate = (id: string, params: RequestParams = {}) =>
        this.http.request<OcpiEndpointsTokensSendUpdateData, any>({
            path: `/api/ocpi/endpoints/${id}/tokens/send`,
            method: "PUT",
            secure: true,
            ...params,
        });
    /**
     * @description Generate OCPI Endpoint's local token
     *
     * @tags OCPI
     * @name OcpiEndpointsTokensGenerateUpdate
     * @request PUT:/api/ocpi/endpoints/{id}/tokens/generate
     * @secure
     * @response `200` `OcpiEndpointsTokensGenerateUpdateData` OCPI Endpoint's local tokens generated
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    ocpiEndpointsTokensGenerateUpdate = (
        id: string,
        data: OcpiEndpointsTokensGenerateUpdatePayload,
        params: RequestParams = {}
    ) =>
        this.http.request<OcpiEndpointsTokensGenerateUpdateData, any>({
            path: `/api/ocpi/endpoints/${id}/tokens/generate`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Register OCPI Endpoint
     *
     * @tags OCPI
     * @name OcpiEndpointsRegisterUpdate
     * @request PUT:/api/ocpi/endpoints/{id}/register
     * @secure
     * @response `200` `OcpiEndpointsRegisterUpdateData` OCPI Endpoint registered
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    ocpiEndpointsRegisterUpdate = (id: string, params: RequestParams = {}) =>
        this.http.request<OcpiEndpointsRegisterUpdateData, any>({
            path: `/api/ocpi/endpoints/${id}/register`,
            method: "PUT",
            secure: true,
            ...params,
        });
    /**
     * @description Unregister OCPI Endpoint
     *
     * @tags OCPI
     * @name OcpiEndpointsUnregisterUpdate
     * @request PUT:/api/ocpi/endpoints/{id}/unregister
     * @secure
     * @response `200` `OcpiEndpointsUnregisterUpdateData` OCPI Endpoint unregistered
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    ocpiEndpointsUnregisterUpdate = (id: string, params: RequestParams = {}) =>
        this.http.request<OcpiEndpointsUnregisterUpdateData, any>({
            path: `/api/ocpi/endpoints/${id}/unregister`,
            method: "PUT",
            secure: true,
            ...params,
        });
    /**
     * @description Update credentials of an OCPI Endpoint
     *
     * @tags OCPI
     * @name OcpiEndpointsCredentialsUpdate
     * @request PUT:/api/ocpi/endpoints/{id}/credentials
     * @secure
     * @response `200` `OcpiEndpointsCredentialsUpdateData` OCPI Endpoint updated
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    ocpiEndpointsCredentialsUpdate = (id: string, params: RequestParams = {}) =>
        this.http.request<OcpiEndpointsCredentialsUpdateData, any>({
            path: `/api/ocpi/endpoints/${id}/credentials`,
            method: "PUT",
            secure: true,
            ...params,
        });
    /**
     * @description Create an OICP Endpoint
     *
     * @tags OICP
     * @name OicpEndpointsCreate
     * @request POST:/api/oicp/endpoints
     * @secure
     * @response `201` `OicpEndpointsCreateData` OICP Endpoint created successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    oicpEndpointsCreate = (data: OICPEndpoint, params: RequestParams = {}) =>
        this.http.request<OicpEndpointsCreateData, any>({
            path: `/api/oicp/endpoints`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Retrieve an OICP Endpoint
     *
     * @tags OICP
     * @name OicpEndpointsDetail
     * @request GET:/api/oicp/endpoints/{id}
     * @secure
     * @response `200` `OicpEndpointsDetailData` Return OICP Endpoint
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    oicpEndpointsDetail = (id: string, params: RequestParams = {}) =>
        this.http.request<OicpEndpointsDetailData, any>({
            path: `/api/oicp/endpoints/${id}`,
            method: "GET",
            secure: true,
            ...params,
        });
    /**
     * @description Update an OICP Endpoint
     *
     * @tags OICP
     * @name OicpEndpointsUpdate
     * @request PUT:/api/oicp/endpoints/{id}
     * @secure
     * @response `200` `OicpEndpointsUpdateData` OICP Endpoint updated successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    oicpEndpointsUpdate = (id: string, data: OICPEndpoint, params: RequestParams = {}) =>
        this.http.request<OicpEndpointsUpdateData, any>({
            path: `/api/oicp/endpoints/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Delete an OICP Endpoint
     *
     * @tags OICP
     * @name OicpEndpointsDelete
     * @request DELETE:/api/oicp/endpoints/{id}
     * @secure
     * @response `200` `OicpEndpointsDeleteData` OICP Endpoint deleted
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    oicpEndpointsDelete = (id: string, params: RequestParams = {}) =>
        this.http.request<OicpEndpointsDeleteData, any>({
            path: `/api/oicp/endpoints/${id}`,
            method: "DELETE",
            secure: true,
            ...params,
        });
    /**
     * @description Ping an OICP Endpoint
     *
     * @tags OICP
     * @name OicpEndpointsPingUpdate
     * @request PUT:/api/oicp/endpoints/{id}/ping
     * @secure
     * @response `200` `OicpEndpointsPingUpdateData` OICP Endpoint is reachable
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    oicpEndpointsPingUpdate = (id: string, data: OICPEndpoint, params: RequestParams = {}) =>
        this.http.request<OicpEndpointsPingUpdateData, any>({
            path: `/api/oicp/endpoints/${id}/ping`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Send OICP EVSE's statuses
     *
     * @tags OICP
     * @name OicpEndpointsEvsesStatusesSendUpdate
     * @request PUT:/api/oicp/endpoints/{id}/evses/statuses/send
     * @secure
     * @response `200` `OicpEndpointsEvsesStatusesSendUpdateData` OICP Endpoint's EVSE's statuses sent
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    oicpEndpointsEvsesStatusesSendUpdate = (id: string, params: RequestParams = {}) =>
        this.http.request<OicpEndpointsEvsesStatusesSendUpdateData, any>({
            path: `/api/oicp/endpoints/${id}/evses/statuses/send`,
            method: "PUT",
            secure: true,
            ...params,
        });
    /**
     * @description Send OICP EVSEs
     *
     * @tags OICP
     * @name OicpEndpointsEvsesSendUpdate
     * @request PUT:/api/oicp/endpoints/{id}/evses/send
     * @secure
     * @response `200` `OicpEndpointsEvsesSendUpdateData` OICP Endpoint's EVSEs sent
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    oicpEndpointsEvsesSendUpdate = (id: string, params: RequestParams = {}) =>
        this.http.request<OicpEndpointsEvsesSendUpdateData, any>({
            path: `/api/oicp/endpoints/${id}/evses/send`,
            method: "PUT",
            secure: true,
            ...params,
        });
    /**
     * @description Register OICP Endpoint
     *
     * @tags OICP
     * @name OicpEndpointsRegisterUpdate
     * @request PUT:/api/oicp/endpoints/{id}/register
     * @secure
     * @response `200` `OicpEndpointsRegisterUpdateData` OCPI Endpoint registered
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    oicpEndpointsRegisterUpdate = (id: string, params: RequestParams = {}) =>
        this.http.request<OicpEndpointsRegisterUpdateData, any>({
            path: `/api/oicp/endpoints/${id}/register`,
            method: "PUT",
            secure: true,
            ...params,
        });
    /**
     * @description Unregister OICP Endpoint
     *
     * @tags OICP
     * @name OicpEndpointsUnregisterUpdate
     * @request PUT:/api/oicp/endpoints/{id}/unregister
     * @secure
     * @response `200` `OicpEndpointsUnregisterUpdateData` OICP Endpoint unregistered
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    oicpEndpointsUnregisterUpdate = (id: string, params: RequestParams = {}) =>
        this.http.request<OicpEndpointsUnregisterUpdateData, any>({
            path: `/api/oicp/endpoints/${id}/unregister`,
            method: "PUT",
            secure: true,
            ...params,
        });
    /**
     * @description Retrieve a list of Settings
     *
     * @tags Settings
     * @name SettingsList
     * @request GET:/api/settings
     * @secure
     * @response `200` `SettingsListData` Return Settings list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    settingsList = (query: SettingsListParams, params: RequestParams = {}) =>
        this.http.request<SettingsListData, any>({
            path: `/api/settings`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Create a Setting
     *
     * @tags Settings
     * @name SettingsCreate
     * @request POST:/api/settings
     * @secure
     * @response `201` `SettingsCreateData` Setting created successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    settingsCreate = (data: Setting, params: RequestParams = {}) =>
        this.http.request<SettingsCreateData, any>({
            path: `/api/settings`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Retrieve a Setting
     *
     * @tags Settings
     * @name SettingsDetail
     * @request GET:/api/settings/{id}
     * @secure
     * @response `200` `SettingsDetailData` Return Setting
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    settingsDetail = (id: string, params: RequestParams = {}) =>
        this.http.request<SettingsDetailData, any>({
            path: `/api/settings/${id}`,
            method: "GET",
            secure: true,
            ...params,
        });
    /**
     * @description Update a Setting
     *
     * @tags Settings
     * @name SettingsUpdate
     * @request PUT:/api/settings/{id}
     * @secure
     * @response `200` `SettingsUpdateData` Setting updated successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    settingsUpdate = (id: string, data: Setting, params: RequestParams = {}) =>
        this.http.request<SettingsUpdateData, any>({
            path: `/api/settings/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Delete a Setting
     *
     * @tags Settings
     * @name SettingsDelete
     * @request DELETE:/api/settings/{id}
     * @secure
     * @response `200` `SettingsDeleteData` Setting deleted successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    settingsDelete = (id: string, params: RequestParams = {}) =>
        this.http.request<SettingsDeleteData, any>({
            path: `/api/settings/${id}`,
            method: "DELETE",
            secure: true,
            ...params,
        });
    /**
     * @description Retrieve a list of Registration Tokens
     *
     * @tags Registration tokens
     * @name RegistrationTokensList
     * @request GET:/api/registration-tokens
     * @secure
     * @response `200` `RegistrationTokensListData` Return Registration Tokens list
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    registrationTokensList = (query: RegistrationTokensListParams, params: RequestParams = {}) =>
        this.http.request<RegistrationTokensListData, any>({
            path: `/api/registration-tokens`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Create a registration token
     *
     * @tags Registration tokens
     * @name RegistrationTokensCreate
     * @request POST:/api/registration-tokens
     * @secure
     * @response `201` `RegistrationTokensCreateData` Registration token created successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    registrationTokensCreate = (data: RegistrationToken, params: RequestParams = {}) =>
        this.http.request<RegistrationTokensCreateData, any>({
            path: `/api/registration-tokens`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Retrieve a Registration Token
     *
     * @tags Registration tokens
     * @name RegistrationTokensDetail
     * @request GET:/api/registration-tokens/{id}
     * @secure
     * @response `200` `RegistrationTokensDetailData` Return registration Token
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    registrationTokensDetail = (id: string, params: RequestParams = {}) =>
        this.http.request<RegistrationTokensDetailData, any>({
            path: `/api/registration-tokens/${id}`,
            method: "GET",
            secure: true,
            ...params,
        });
    /**
     * @description Update a Registration Token
     *
     * @tags Registration tokens
     * @name RegistrationTokensUpdate
     * @request PUT:/api/registration-tokens/{id}
     * @secure
     * @response `200` `RegistrationTokensUpdateData` Registration Token updated successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    registrationTokensUpdate = (id: string, data: RegistrationToken, params: RequestParams = {}) =>
        this.http.request<RegistrationTokensUpdateData, any>({
            path: `/api/registration-tokens/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Delete a Registration Token
     *
     * @tags Registration tokens
     * @name RegistrationTokensDelete
     * @request DELETE:/api/registration-tokens/{id}
     * @secure
     * @response `200` `RegistrationTokensDeleteData` Registration Token deleted successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    registrationTokensDelete = (id: string, params: RequestParams = {}) =>
        this.http.request<RegistrationTokensDeleteData, any>({
            path: `/api/registration-tokens/${id}`,
            method: "DELETE",
            secure: true,
            ...params,
        });
    /**
     * @description Revoke a Registration Token
     *
     * @tags Registration tokens
     * @name RegistrationTokensRevokeUpdate
     * @request PUT:/api/registration-tokens/{id}/revoke
     * @secure
     * @response `200` `RegistrationTokensRevokeUpdateData` Registration Token revoked successfully
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    registrationTokensRevokeUpdate = (id: string, params: RequestParams = {}) =>
        this.http.request<RegistrationTokensRevokeUpdateData, any>({
            path: `/api/registration-tokens/${id}/revoke`,
            method: "PUT",
            secure: true,
            ...params,
        });
    /**
     * @description Export Statistics
     *
     * @tags Statistics
     * @name StatisticsActionExportList
     * @request GET:/api/statistics/action/export
     * @secure
     * @response `200` `StatisticsActionExportListData` Return statistics
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    statisticsActionExportList = (query: StatisticsActionExportListParams, params: RequestParams = {}) =>
        this.http.request<StatisticsActionExportListData, any>({
            path: `/api/statistics/action/export`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Get Charging stations consumption Statistics
     *
     * @tags Statistics
     * @name StatisticsChargingStationsConsumptionList
     * @request GET:/api/statistics/charging-stations/consumption
     * @secure
     * @response `200` `StatisticsChargingStationsConsumptionListData` Return charging stations consumption statistics
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    statisticsChargingStationsConsumptionList = (
        query: StatisticsChargingStationsConsumptionListParams,
        params: RequestParams = {}
    ) =>
        this.http.request<StatisticsChargingStationsConsumptionListData, any>({
            path: `/api/statistics/charging-stations/consumption`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Get Charging stations usage Statistics
     *
     * @tags Statistics
     * @name StatisticsChargingStationsUsageList
     * @request GET:/api/statistics/charging-stations/usage
     * @secure
     * @response `200` `StatisticsChargingStationsUsageListData` Return charging stations usage statistics
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    statisticsChargingStationsUsageList = (
        query: StatisticsChargingStationsUsageListParams,
        params: RequestParams = {}
    ) =>
        this.http.request<StatisticsChargingStationsUsageListData, any>({
            path: `/api/statistics/charging-stations/usage`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Get Charging stations inactivity Statistics
     *
     * @tags Statistics
     * @name StatisticsChargingStationsInactivityList
     * @request GET:/api/statistics/charging-stations/inactivity
     * @secure
     * @response `200` `StatisticsChargingStationsInactivityListData` Return charging stations inactivity statistics
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    statisticsChargingStationsInactivityList = (
        query: StatisticsChargingStationsInactivityListParams,
        params: RequestParams = {}
    ) =>
        this.http.request<StatisticsChargingStationsInactivityListData, any>({
            path: `/api/statistics/charging-stations/inactivity`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Get Charging stations transactions Statistics
     *
     * @tags Statistics
     * @name StatisticsChargingStationsTransactionsList
     * @request GET:/api/statistics/charging-stations/transactions
     * @secure
     * @response `200` `StatisticsChargingStationsTransactionsListData` Return charging stations transactions statistics
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    statisticsChargingStationsTransactionsList = (
        query: StatisticsChargingStationsTransactionsListParams,
        params: RequestParams = {}
    ) =>
        this.http.request<StatisticsChargingStationsTransactionsListData, any>({
            path: `/api/statistics/charging-stations/transactions`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Get Charging stations princing Statistics
     *
     * @tags Statistics
     * @name StatisticsChargingStationsPricingList
     * @request GET:/api/statistics/charging-stations/pricing
     * @secure
     * @response `200` `StatisticsChargingStationsPricingListData` Return charging stations pricing statistics
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    statisticsChargingStationsPricingList = (
        query: StatisticsChargingStationsPricingListParams,
        params: RequestParams = {}
    ) =>
        this.http.request<StatisticsChargingStationsPricingListData, any>({
            path: `/api/statistics/charging-stations/pricing`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Get users consumption Statistics
     *
     * @tags Statistics
     * @name StatisticsUsersConsumptionList
     * @request GET:/api/statistics/users/consumption
     * @secure
     * @response `200` `StatisticsUsersConsumptionListData` Return user consumption statistics
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    statisticsUsersConsumptionList = (query: StatisticsUsersConsumptionListParams, params: RequestParams = {}) =>
        this.http.request<StatisticsUsersConsumptionListData, any>({
            path: `/api/statistics/users/consumption`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Get users usage Statistics
     *
     * @tags Statistics
     * @name StatisticsUsersUsageList
     * @request GET:/api/statistics/users/usage
     * @secure
     * @response `200` `StatisticsUsersUsageListData` Return users usage statistics
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    statisticsUsersUsageList = (query: StatisticsUsersUsageListParams, params: RequestParams = {}) =>
        this.http.request<StatisticsUsersUsageListData, any>({
            path: `/api/statistics/users/usage`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Get users inactivity Statistics
     *
     * @tags Statistics
     * @name StatisticsUsersInactivityList
     * @request GET:/api/statistics/users/inactivity
     * @secure
     * @response `200` `StatisticsUsersInactivityListData` Return users inactivity statistics
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    statisticsUsersInactivityList = (query: StatisticsUsersInactivityListParams, params: RequestParams = {}) =>
        this.http.request<StatisticsUsersInactivityListData, any>({
            path: `/api/statistics/users/inactivity`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Get users transactions Statistics
     *
     * @tags Statistics
     * @name StatisticsUsersTransactionsList
     * @request GET:/api/statistics/users/transactions
     * @secure
     * @response `200` `StatisticsUsersTransactionsListData` Return users transactions statistics
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    statisticsUsersTransactionsList = (query: StatisticsUsersTransactionsListParams, params: RequestParams = {}) =>
        this.http.request<StatisticsUsersTransactionsListData, any>({
            path: `/api/statistics/users/transactions`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Get users princing Statistics
     *
     * @tags Statistics
     * @name StatisticsUsersPricingList
     * @request GET:/api/statistics/users/pricing
     * @secure
     * @response `200` `StatisticsUsersPricingListData` Return users pricing statistics
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    statisticsUsersPricingList = (query: StatisticsUsersPricingListParams, params: RequestParams = {}) =>
        this.http.request<StatisticsUsersPricingListData, any>({
            path: `/api/statistics/users/pricing`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Get billing taxes
     *
     * @tags Billing
     * @name BillingTaxesList
     * @request GET:/api/billing/taxes
     * @secure
     * @response `200` `BillingTaxesListData`
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    billingTaxesList = (params: RequestParams = {}) =>
        this.http.request<BillingTaxesListData, any>({
            path: `/api/billing/taxes`,
            method: "GET",
            secure: true,
            ...params,
        });
    /**
     * @description Get billing settings
     *
     * @tags Billing
     * @name BillingSettingList
     * @request GET:/api/billing-setting
     * @secure
     * @response `200` `BillingSettingListData` Return billing settings
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    billingSettingList = (params: RequestParams = {}) =>
        this.http.request<BillingSettingListData, any>({
            path: `/api/billing-setting`,
            method: "GET",
            secure: true,
            ...params,
        });
    /**
     * @description Update billing settings
     *
     * @tags Billing
     * @name BillingSettingUpdate
     * @request PUT:/api/billing-setting
     * @secure
     * @response `200` `BillingSettingUpdateData` Billing settings successfully updated
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    billingSettingUpdate = (data: BillingSettingUpdatePayload, params: RequestParams = {}) =>
        this.http.request<BillingSettingUpdateData, any>({
            path: `/api/billing-setting`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Check the connection with the billing provider
     *
     * @tags Billing
     * @name BillingCheckCreate
     * @request POST:/api/billing/check
     * @secure
     * @response `200` `BillingCheckCreateData` Billing provider is reachable
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    billingCheckCreate = (params: RequestParams = {}) =>
        this.http.request<BillingCheckCreateData, any>({
            path: `/api/billing/check`,
            method: "POST",
            secure: true,
            ...params,
        });
    /**
     * @description Get Accounts
     *
     * @tags Billing
     * @name BillingAccountsList
     * @request GET:/api/billing/accounts
     * @secure
     * @response `200` `BillingAccountsListData` Return accounts
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    billingAccountsList = (query: BillingAccountsListParams, params: RequestParams = {}) =>
        this.http.request<BillingAccountsListData, any>({
            path: `/api/billing/accounts`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Create a Billing account
     *
     * @tags Billing
     * @name BillingAccountsCreate
     * @request POST:/api/billing/accounts
     * @secure
     * @response `201` `BillingAccountsCreateData` Pending account created
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    billingAccountsCreate = (data: BillingAccountsCreatePayload, params: RequestParams = {}) =>
        this.http.request<BillingAccountsCreateData, any>({
            path: `/api/billing/accounts`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
    /**
     * @description Get Accounts
     *
     * @tags Billing
     * @name BillingAccountsDetail
     * @request GET:/api/billing/accounts/{id}
     * @secure
     * @response `200` `BillingAccountsDetailData` Return account
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     * @response `550` `any`
     */
    billingAccountsDetail = (id: string, params: RequestParams = {}) =>
        this.http.request<BillingAccountsDetailData, any>({
            path: `/api/billing/accounts/${id}`,
            method: "GET",
            secure: true,
            ...params,
        });
    /**
     * @description Send onboarding to account's owner
     *
     * @tags Billing
     * @name BillingAccountsOnboardPartialUpdate
     * @request PATCH:/api/billing/accounts/{id}/onboard
     * @secure
     * @response `200` `BillingAccountsOnboardPartialUpdateData` Sent the account onboarding link by mail
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     * @response `550` `any`
     */
    billingAccountsOnboardPartialUpdate = (id: string, params: RequestParams = {}) =>
        this.http.request<BillingAccountsOnboardPartialUpdateData, any>({
            path: `/api/billing/accounts/${id}/onboard`,
            method: "PATCH",
            secure: true,
            ...params,
        });
    /**
     * @description Get Transfers
     *
     * @tags Billing
     * @name BillingTransfersList
     * @request GET:/api/billing/transfers
     * @secure
     * @response `200` `BillingTransfersListData` Return transfers
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    billingTransfersList = (query: BillingTransfersListParams, params: RequestParams = {}) =>
        this.http.request<BillingTransfersListData, any>({
            path: `/api/billing/transfers`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Finalize a Transfer
     *
     * @tags Billing
     * @name BillingTransfersFinalizePartialUpdate
     * @request PATCH:/api/billing/transfers/{id}/finalize
     * @secure
     * @response `200` `BillingTransfersFinalizePartialUpdateData` Transfer finalized
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     * @response `550` `any`
     */
    billingTransfersFinalizePartialUpdate = (id: string, params: RequestParams = {}) =>
        this.http.request<BillingTransfersFinalizePartialUpdateData, any>({
            path: `/api/billing/transfers/${id}/finalize`,
            method: "PATCH",
            secure: true,
            ...params,
        });
    /**
     * @description Triggers the transfer of funds to the account
     *
     * @tags Billing
     * @name BillingTransfersSendPartialUpdate
     * @request PATCH:/api/billing/transfers/{id}/send
     * @secure
     * @response `200` `BillingTransfersSendPartialUpdateData` Transfer sent
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     * @response `550` `any`
     */
    billingTransfersSendPartialUpdate = (id: string, params: RequestParams = {}) =>
        this.http.request<BillingTransfersSendPartialUpdateData, any>({
            path: `/api/billing/transfers/${id}/send`,
            method: "PATCH",
            secure: true,
            ...params,
        });
    /**
     * @description Get Invoices
     *
     * @tags Billing
     * @name InvoicesList
     * @request GET:/api/invoices
     * @secure
     * @response `200` `InvoicesListData` Return invoices
     * @response `401` `any`
     * @response `403` `any`
     * @response `500` `any`
     */
    invoicesList = (query: InvoicesListParams, params: RequestParams = {}) =>
        this.http.request<InvoicesListData, any>({
            path: `/api/invoices`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        });
    /**
     * @description Get Invoice by id
     *
     * @tags Billing
     * @name InvoicesDetail
     * @request GET:/api/invoices/{id}
     * @secure
     * @response `200` `InvoicesDetailData` Return invoice
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    invoicesDetail = (id: string, params: RequestParams = {}) =>
        this.http.request<InvoicesDetailData, any>({
            path: `/api/invoices/${id}`,
            method: "GET",
            secure: true,
            ...params,
        });
    /**
     * @description Download Invoice as PDF
     *
     * @tags Billing
     * @name InvoicesDownloadDetail
     * @request GET:/api/invoices/{id}/download
     * @secure
     * @response `200` `InvoicesDownloadDetailData` Return invoice as PDF
     * @response `401` `any`
     * @response `403` `any`
     * @response `404` `any`
     * @response `500` `any`
     */
    invoicesDownloadDetail = (id: string, params: RequestParams = {}) =>
        this.http.request<InvoicesDownloadDetailData, any>({
            path: `/api/invoices/${id}/download`,
            method: "GET",
            secure: true,
            ...params,
        });

    getTransactionsOtp = (tenantId: string, sessionId: string, payload: TransactionOtp) => {
        return this.http.request<any, any>({
            path: `/transactions-otp/${tenantId}/${sessionId}`,
            method: "POST",
            body: payload,
            secure: true,
        });
    }

    stopTransactionOtp = (tenantId: string, sessionId: string, payload: TransactionOtp) => {
        return this.http.request({
            path: `/transactions-otp/${tenantId}/${sessionId}/stop`,
            method: 'POST',
            body: payload,
            secure: true
        });
    }

    getPaymentTerminalBillingDetailsSession = (
        tenantId: string,
        token: string,
        verificationToken: string | null | undefined,
    ) => {
        return this.http.request<PaymentTerminalBillingDetailsSessionData, any>({
            path: `/payment-terminal-attestation/${tenantId}/billing-details/${token}`,
            method: 'GET',
            query: { verificationToken },
            secure: false,
        });
    }

    submitPaymentTerminalBillingDetails = (
        tenantId: string,
        token: string,
        verificationToken: string | null | undefined,
        billingDetails: PaymentTerminalBillingDetails,
    ) => {
        return this.http.request<PaymentTerminalBillingDetailsSubmitData, any>({
            path: `/payment-terminal-attestation/${tenantId}/billing-details/${token}`,
            method: 'POST',
            body: { verificationToken, billingDetails },
            secure: false,
        });
    }

    lookupPaymentTerminalBillingDetailsTaxId = (
        tenantId: string,
        token: string,
        verificationToken: string | null | undefined,
        lookup: PaymentTerminalBillingDetailsTaxIdLookupRequest,
    ) => {
        return this.http.request<PaymentTerminalBillingDetailsTaxIdLookupData, any>({
            path: `/payment-terminal-attestation/${tenantId}/billing-details/${token}/tax-id/lookup`,
            method: 'POST',
            body: { verificationToken, ...lookup },
            secure: false,
        });
    }
}

export interface TransactionOtp {
    token: string;
    deviceID: string;
}

export interface PaymentTerminalBillingDetails {
    schemaVersion: 1;
    recipient?: PaymentTerminalBillingDetailsRecipient;
    address?: PaymentTerminalBillingDetailsAddress;
    contact?: PaymentTerminalBillingDetailsContact;
}

export interface PaymentTerminalBillingDetailsRecipient {
    type?: 'BUSINESS' | 'INDIVIDUAL';
    name?: string;
    taxCountryCode?: string;
    taxId?: string;
    normalizedTaxId?: string;
}

export interface PaymentTerminalBillingDetailsAddress {
    rawAddress?: string;
    line1?: string;
    line2?: string;
    city?: string;
    region?: string;
    postalCode?: string;
    countryCode?: string;
}

export interface PaymentTerminalBillingDetailsContact {
    email?: string;
    phone?: string;
}

export interface PaymentTerminalBillingDetailsTaxIdLookupRequest {
    taxCountryCode: string;
    taxId: string;
    recipientType: 'BUSINESS' | 'INDIVIDUAL';
}

export interface PaymentTerminalBillingDetailsTaxIdLookupData {
    canContinue?: boolean;
    normalizedTaxId?: string;
    countryCode?: string;
    primaryProvider?: 'aade' | 'anaf' | 'vies' | 'none';
    identityStatus?: 'verified' | 'not_found' | 'temporarily_unavailable' | 'not_verified';
    euVatStatus?: 'verified' | 'invalid' | 'not_vat_registered' | 'temporarily_unavailable' | 'not_applicable' | 'not_verified';
    autofill?: {
        legalName?: string;
        rawAddress?: string;
        countryCode?: string;
        source?: string;
    };
}

export interface PaymentTerminalBillingDetailsTaxLookup {
    requestId?: string;
    checkedOn?: string;
    countryCode?: string;
    normalizedTaxId?: string;
    primaryProvider?: string;
    identityStatus?: string;
    euVatStatus?: string;
    autofill?: PaymentTerminalBillingDetailsTaxIdLookupData['autofill'];
    warnings?: string[];
}

export interface PaymentTerminalBillingDetailsSessionData {
    token: string;
    status: string;
    /** Originating session contract. Older servers omit this and use the production legacy contract. */
    billingContract?: 'legacy' | 'romanian-business-v1' | 'billing-policy-v1';
    currency?: string;
    countryCode?: string;
    expiresAt?: string;
    submitted?: boolean;
    taxLookup?: PaymentTerminalBillingDetailsTaxLookup;
    billingDetailsCollection?: BillingDetailsCollectionPolicy;
}

export interface PaymentTerminalBillingDetailsSubmitData {
    status: string;
}

export interface BillingDetailsCollectionPolicy {
    enabled: boolean;
    mode?: string;
    ruleId?: string;
    context?: BillingDetailsCollectionContext;
    form?: BillingDetailsCollectionForm;
}

export interface BillingDetailsCollectionContext {
    paymentChannel?: string;
    locationCountryCode?: string;
    currency?: string;
}

export interface BillingDetailsCollectionForm {
    defaultRecipientType?: 'BUSINESS' | 'INDIVIDUAL';
    recipientTypes?: Array<'BUSINESS' | 'INDIVIDUAL'>;
    defaultTaxCountryCode?: string;
    allowedTaxCountryCodes?: string[];
    lookup?: { enabled?: boolean };
}

export default new Api(new HttpClient(http));
